"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9642],{

/***/ 9582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Avatar; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Avatar/context.js

/* harmony default export */ var context = ((0,react.createContext)({}));

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Avatar/avatar.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var defaultProps = {
    shape: 'circle',
    autoFixFontSize: true,
    triggerType: 'button',
};
var Avatar = (0,react.forwardRef)(function (props, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var prefixCls = getPrefixCls('avatar');
    var contextProps = (0,react.useContext)(context);
    var mergedProps = __assign(__assign(__assign(__assign({}, defaultProps), componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Avatar), contextProps), props);
    var className = mergedProps.className, shape = mergedProps.shape, size = mergedProps.size, children = mergedProps.children, autoFixFontSize = mergedProps.autoFixFontSize, triggerIcon = mergedProps.triggerIcon, triggerIconStyle = mergedProps.triggerIconStyle, triggerType = mergedProps.triggerType, onClick = mergedProps.onClick, rest = __rest(mergedProps, ["className", "shape", "size", "children", "autoFixFontSize", "triggerIcon", "triggerIconStyle", "triggerType", "onClick"]);
    var style = __assign(__assign({}, contextProps.style), props.style);
    var textRef = (0,react.useRef)(null);
    var avatarRef = (0,react.useRef)(null);
    (0,react.useEffect)(function () {
        if (autoFixFontSize) {
            autoFixFontSizeHandler();
        }
    }, [size, children]);
    (0,react.useImperativeHandle)(ref, function () { return avatarRef.current; });
    // auto adjust font size
    function autoFixFontSizeHandler() {
        if (textRef.current) {
            var textWidth = textRef.current.clientWidth;
            var size_1 = props.size || avatarRef.current.offsetWidth;
            var scale = size_1 / (textWidth + 8);
            if (size_1 && scale < 1) {
                textRef.current.style.transform = "scale(" + scale + ") translateX(-50%)";
            }
        }
    }
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-" + shape, (_a = {},
        _a[prefixCls + "-with-trigger-icon"] = triggerIcon,
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var childrenList = react.Children.toArray(children);
    var isImage = childrenList.length === 1 &&
        react.isValidElement(childrenList[0]) &&
        (childrenList[0].type === 'img' || childrenList[0].type === 'picture');
    var _triggerIconStyle = triggerIconStyle || {};
    if (triggerType === 'button' &&
        (!triggerIconStyle || (triggerIconStyle && !triggerIconStyle.color)) &&
        style &&
        style.backgroundColor) {
        _triggerIconStyle.color = style.backgroundColor;
    }
    return (react.createElement("div", __assign({ ref: avatarRef, onClick: onClick }, rest, { style: __assign({ width: size, height: size, fontSize: (0,is/* isNumber */.hj)(size) ? size / 2 : '' }, style), className: classNames }),
        isImage ? react.createElement("span", { className: prefixCls + "-image" }, children) : null,
        !isImage && (react.createElement("span", { ref: textRef, className: prefixCls + "-text" }, children)),
        triggerIcon && (react.createElement("div", { className: prefixCls + "-trigger-icon-" + triggerType, style: _triggerIconStyle }, triggerIcon))));
});
Avatar.displayName = 'Avatar';
/* harmony default export */ var avatar = (Avatar);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Popover/index.js
var Popover = __webpack_require__(27339);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Avatar/group.js
var group_assign = (undefined && undefined.__assign) || function () {
    group_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return group_assign.apply(this, arguments);
};
var group_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};








var group_defaultProps = {
    shape: 'circle',
    autoFixFontSize: true,
};
function Group(baseProps, ref) {
    var _a;
    var _b = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _b.getPrefixCls, componentConfig = _b.componentConfig, rtl = _b.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, group_defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig['Avatar.Group']);
    var className = props.className, style = props.style, children = props.children, size = props.size, shape = props.shape, autoFixFontSize = props.autoFixFontSize, zIndexAscend = props.zIndexAscend, maxCount = props.maxCount, maxStyle = props.maxStyle, maxPopoverTriggerProps = props.maxPopoverTriggerProps, rest = group_rest(props, ["className", "style", "children", "size", "shape", "autoFixFontSize", "zIndexAscend", "maxCount", "maxStyle", "maxPopoverTriggerProps"]);
    var prefixCls = getPrefixCls('avatar-group');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, (_a = {},
        _a[prefixCls + "-rtl"] = rtl,
        _a), className);
    var childrenArr = react.Children.toArray(children);
    var avatarCount = childrenArr.length;
    var avatarsToRender = childrenArr;
    if ((0,is/* isNumber */.hj)(maxCount) && maxCount >= 0 && avatarCount > maxCount) {
        var avatarsInPopover = childrenArr.slice(maxCount);
        avatarsToRender = childrenArr.slice(0, maxCount);
        avatarsToRender.push(react.createElement(avatar, { key: "_arco_avatar_group_popup", style: maxStyle, className: prefixCls + "-max-count-avatar" },
            react.createElement(Popover/* default */.Z, { triggerProps: maxPopoverTriggerProps, content: react.createElement(context.Provider, { value: { size: size, shape: shape, autoFixFontSize: autoFixFontSize } },
                    react.createElement("div", { className: prefixCls + "-popover" }, avatarsInPopover)) },
                "+",
                avatarsInPopover.length)));
    }
    return (react.createElement("div", group_assign({ ref: ref, style: style, className: classNames }, rest), avatarsToRender.map(function (item, index) {
        var isFirst = rtl ? index === avatarsToRender.length - 1 : index === 0;
        var stackedStyle = {
            zIndex: zIndexAscend ? index + 1 : avatarCount - index,
            marginLeft: size ? (!isFirst ? -size / 4 : 0) : '',
        };
        return (react.createElement(context.Provider, { key: index, value: { size: size, shape: shape, autoFixFontSize: autoFixFontSize, style: stackedStyle } }, item));
    })));
}
var AvatarGroupComponent = (0,react.forwardRef)(Group);
AvatarGroupComponent.displayName = 'AvatarGroup';
/* harmony default export */ var group = (AvatarGroupComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Avatar/index.js



var AvatarComponent = avatar;
AvatarComponent.Group = group;
/* harmony default export */ var es_Avatar = (AvatarComponent);


/***/ }),

/***/ 49345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87462);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4245);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function IconUserComponent(iconProps, ref) {
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_context__WEBPACK_IMPORTED_MODULE_2__/* .IconContext */ .P),
      _useContext$prefixCls = _useContext.prefixCls,
      prefixCls = _useContext$prefixCls === void 0 ? 'arco' : _useContext$prefixCls;

  var spin = iconProps.spin,
      className = iconProps.className;

  var props = _objectSpread(_objectSpread({
    "aria-hidden": true,
    focusable: false,
    ref: ref
  }, iconProps), {}, {
    className: "".concat(className ? className + ' ' : '').concat(prefixCls, "-icon ").concat(prefixCls, "-icon-user")
  });

  if (spin) {
    props.className = "".concat(props.className, " ").concat(prefixCls, "-icon-loading");
  }

  delete props.spin;
  delete props.isIcon;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("svg", (0,_babel_runtime_helpers_extends__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "4",
    viewBox: "0 0 48 48"
  }, props), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("path", {
    d: "M7 37c0-4.97 4.03-8 9-8h16c4.97 0 9 3.03 9 8v3a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-3Z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("circle", {
    cx: "24",
    cy: "15",
    r: "8"
  }));
}

var IconUser = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(IconUserComponent);
IconUser.defaultProps = {
  isIcon: true
};
IconUser.displayName = 'IconUser';
/* harmony default export */ __webpack_exports__["Z"] = (IconUser);

/***/ }),

/***/ 5199:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
// 注册需要的动画执行函数
var fade_1 = __webpack_require__(93071);
var grow_in_1 = __webpack_require__(34642);
var path_in_1 = __webpack_require__(2154);
var position_update_1 = __webpack_require__(48855);
var scale_in_1 = __webpack_require__(49003);
var sector_path_update_1 = __webpack_require__(25626);
var wave_in_1 = __webpack_require__(8216);
var zoom_1 = __webpack_require__(8225);
var core_1 = __webpack_require__(85096);
core_1.registerAnimation('fade-in', fade_1.fadeIn);
core_1.registerAnimation('fade-out', fade_1.fadeOut);
core_1.registerAnimation('grow-in-x', grow_in_1.growInX);
core_1.registerAnimation('grow-in-xy', grow_in_1.growInXY);
core_1.registerAnimation('grow-in-y', grow_in_1.growInY);
core_1.registerAnimation('scale-in-x', scale_in_1.scaleInX);
core_1.registerAnimation('scale-in-y', scale_in_1.scaleInY);
core_1.registerAnimation('wave-in', wave_in_1.waveIn);
core_1.registerAnimation('zoom-in', zoom_1.zoomIn);
core_1.registerAnimation('zoom-out', zoom_1.zoomOut);
core_1.registerAnimation('position-update', position_update_1.positionUpdate);
core_1.registerAnimation('sector-path-update', sector_path_update_1.sectorPathUpdate);
core_1.registerAnimation('path-in', path_in_1.pathIn);
//# sourceMappingURL=animations.js.map

/***/ }),

/***/ 7245:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setDefaultErrorFallback = exports.ErrorFallback = void 0;
var react_1 = __importDefault(__webpack_require__(67294));
var react_error_boundary_1 = __webpack_require__(35800);
var DefaultErrorFallback = function (_a) {
    var error = _a.error;
    return (react_1.default.createElement("div", { className: "bizcharts-error", role: "alert" },
        react_1.default.createElement("p", null, "BizCharts something went wrong:"),
        react_1.default.createElement("pre", null, error.message)));
};
function ErrorFallback(args) {
    return DefaultErrorFallback(args);
}
exports.ErrorFallback = ErrorFallback;
exports.setDefaultErrorFallback = function (CustComponents) {
    DefaultErrorFallback = CustComponents;
};
exports["default"] = react_error_boundary_1.ErrorBoundary;
//# sourceMappingURL=ErrorBoundary.js.map

/***/ }),

/***/ 377:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(67294));
function withContainer(Component, name) {
    if (name === void 0) { name = 'ChartContainer'; }
    var Cls = react_1.default.forwardRef(function (props, ref) {
        var container = react_1.useRef();
        var _a = react_1.useState(false), inited = _a[0], setInited = _a[1];
        var _b = props, _c = _b.className, className = _c === void 0 ? "bizcharts" : _c, containerStyle = _b.containerStyle, options = __rest(_b, ["className", "containerStyle"]);
        react_1.useEffect(function () {
            setInited(true);
        }, []);
        // @ts-ignore
        return react_1.default.createElement("div", { ref: container, className: className, 
            // @ts-ignore
            style: __assign({ position: 'relative', height: props.height || '100%', width: props.width || '100%' }, containerStyle) }, inited ? react_1.default.createElement(Component, __assign({ ref: ref, container: container.current }, options)) : react_1.default.createElement(react_1.default.Fragment, null));
    });
    Cls.displayName = name || Component.name;
    return Cls;
}
exports["default"] = withContainer;
;
//# sourceMappingURL=withContainer.js.map

/***/ }),

/***/ 48226:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var axis_1 = __importDefault(__webpack_require__(32709));
var useChartView_1 = __importDefault(__webpack_require__(45950));
var transBooleanCfg_1 = __importDefault(__webpack_require__(54512));
var core_1 = __webpack_require__(88009);
core_1.registerComponentController('axis', axis_1.default);
var undefinedField = function (name) { return (name === undefined); };
var mixinAxisCfg = function (options) {
    // 兼容boolean类型的配置 例： <Axis title /> 
    return transBooleanCfg_1.default(options, ['title', 'line', 'tickLine', 'subTickLine', 'label', 'grid']);
};
function Axis(props) {
    var name = props.name, _a = props.visible, visible = _a === void 0 ? true : _a, options = __rest(props, ["name", "visible"]);
    var view = useChartView_1.default();
    var newConfig = mixinAxisCfg(options);
    // warning(newConfig.grid !== null, 'fix g2 bug: Axis null 请先在Chart上配置forceUpdate 强制刷新以等待g2 修复。');
    if (visible) {
        if (undefinedField(name)) {
            // 不指定字段名称，仅visible生效
            view.axis(true);
        }
        else {
            view.axis(name, newConfig);
        }
    }
    else {
        if (undefinedField(name)) {
            view.axis(false);
        }
        else {
            view.axis(name, false);
        }
    }
    return null;
}
exports["default"] = Axis;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29182:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var unique_id_1 = __importDefault(__webpack_require__(67250));
var each_1 = __importDefault(__webpack_require__(27154));
var is_function_1 = __importDefault(__webpack_require__(46812));
var is_array_1 = __importDefault(__webpack_require__(66631));
var is_equal_1 = __importDefault(__webpack_require__(212));
var core_1 = __webpack_require__(88009);
var warning_1 = __importDefault(__webpack_require__(42473));
var shallowEqual_1 = __importDefault(__webpack_require__(41041));
var pickWithout_1 = __importDefault(__webpack_require__(88647));
var cloneDeep_1 = __importDefault(__webpack_require__(56956));
var constant_1 = __webpack_require__(50891);
var constant_2 = __webpack_require__(29583);
var event_emitter_1 = __importDefault(__webpack_require__(90494));
var events_1 = __webpack_require__(20370);
var processData = function (data) {
    if (data && data.rows) {
        return data.rows;
    }
    return data;
};
var ChartHelper = /** @class */ (function (_super) {
    __extends(ChartHelper, _super);
    function ChartHelper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.config = {};
        return _this;
    }
    ChartHelper.prototype.createInstance = function (config) {
        this.chart = new core_1.Chart(__assign({}, config));
        this.key = unique_id_1.default('bx-chart');
        this.chart.emit('initialed');
        this.isNewInstance = true; // 更新了实例的标记
        this.extendGroup = {
            isChartCanvas: true,
            chart: this.chart,
        };
    };
    ChartHelper.prototype.render = function () {
        if (!this.chart) {
            return;
        }
        try {
            // 普通error 只能兜住react render周期里的error。 chart render周期的error 要单独处理
            if (this.isNewInstance) {
                this.chart.render();
                this.onGetG2Instance();
                // @ts-ignore
                this.chart.unbindAutoFit(); // 不使用g2的监听
                this.isNewInstance = false;
                // @ts-ignore
            }
            else if (this.chart.forceReRender) {
                // forceReRender 填部分g2更新不干净的坑
                this.chart.render();
            }
            else {
                this.chart.render(true);
            }
            // 处理elements状态
            this.chart.emit('processElemens');
        }
        catch (e) {
            this.emit('renderError', e);
            this.destory();
            if (console) {
                console.error(e === null || e === void 0 ? void 0 : e.stack);
            }
        }
    };
    ChartHelper.prototype.onGetG2Instance = function () {
        // 当且仅当 isNewInstance 的时候执行。
        if (is_function_1.default(this.config.onGetG2Instance)) {
            this.config.onGetG2Instance(this.chart);
        }
    };
    ChartHelper.prototype.shouldReCreateInstance = function (newConfig) {
        // 如果上一个实例数据为空则直接销毁重建，以免影响动画
        if (!this.chart || newConfig.forceUpdate) {
            return true;
        }
        var _a = this.config, preData = _a.data, preOptions = __rest(_a, ["data"]);
        var data = newConfig.data, options = __rest(newConfig, ["data"]);
        if (is_array_1.default(this.config.data)
            && preData.length === 0
            && is_array_1.default(data)
            && data.length !== 0) {
            return true;
        }
        // scale 切换不需要重建实例
        var unCompareProps = __spreadArrays(constant_1.REACT_PIVATE_PROPS, ['scale', 'width', 'height', 'container', '_container', '_interactions', 'placeholder', /^on/, /^\_on/]);
        if (!is_equal_1.default(pickWithout_1.default(preOptions, __spreadArrays(unCompareProps)), pickWithout_1.default(options, __spreadArrays(unCompareProps)))) {
            return true;
        }
        return false;
    };
    ChartHelper.prototype.update = function (props) {
        var _this = this;
        var newConfig = cloneDeep_1.default(this.adapterOptions(props));
        if (this.shouldReCreateInstance(newConfig)) {
            this.destory();
            this.createInstance(newConfig);
        }
        // 重置
        if (newConfig.pure) {
            // 纯画布 关闭
            this.chart.axis(false);
            this.chart.tooltip(false);
            this.chart.legend(false);
            // @ts-ignore
            this.chart.isPure = true;
        }
        // 事件
        var events = events_1.pickEventName(this.config);
        var newEvents = events_1.pickEventName(newConfig);
        // 配置
        var data = newConfig.data, interactions = newConfig.interactions, options = __rest(newConfig, ["data", "interactions"]);
        var _a = this.config, preData = _a.data, _b = _a.interactions, preInteractions = _b === void 0 ? [] : _b;
        if (!this.isNewInstance) {
            // 取消事件绑定
            events.forEach(function (ev) {
                _this.chart.off(ev[1], _this.config["_" + ev[0]]);
            });
        }
        /** 更新 */
        // 绑定事件
        newEvents.forEach(function (evName) {
            newConfig["_" + evName[0]] = function (ev) {
                // 输入chart实例方便用户使用
                newConfig[evName[0]](ev, _this.chart);
            };
            _this.chart.on(evName[1], newConfig["_" + evName[0]]);
        });
        // 数据 更新
        if (is_array_1.default(preData) && preData.length) {
            // 数据只做2级浅比较
            // fixme: 做4级比较
            var isEqual_1 = true;
            if (newConfig.notCompareData) {
                // 手动关闭对比
                isEqual_1 = false;
            }
            if (preData.length !== data.length) {
                // 长度不相等
                isEqual_1 = false;
            }
            else {
                preData.forEach(function (element, index) {
                    if (!shallowEqual_1.default(element, data[index])) {
                        isEqual_1 = false;
                    }
                });
            }
            if (!isEqual_1) {
                // @ts-ignore
                this.chart.isDataChanged = true;
                this.chart.emit(constant_2.VIEW_LIFE_CIRCLE.BEFORE_CHANGE_DATA);
                // 1. 保存数据
                this.chart.data(data);
                // 2. 最后再渲染
                // 3. 遍历子 view 进行 change data
                var views = this.chart.views;
                for (var i = 0, len = views.length; i < len; i++) {
                    var view = views[i];
                    // 子 view 有自己的数据, 会在执行view的配置时会覆盖
                    view.changeData(data);
                }
                this.chart.emit(constant_2.VIEW_LIFE_CIRCLE.AFTER_CHANGE_DATA);
            }
        }
        else {
            this.chart.data(data);
        }
        // 比例尺
        this.chart.scale(options.scale);
        // 动画
        if (options.animate === false) {
            this.chart.animate(false);
        }
        else {
            this.chart.animate(true);
        }
        // 交互 interactions
        preInteractions.forEach(function (interact) {
            // 这里不做对比，无意义，都是要销毁重建，不如直接全量销毁
            _this.chart.removeInteraction(interact);
        });
        interactions.forEach(function (interact) {
            _this.chart.interaction(interact);
        });
        // filter
        each_1.default(this.config.filter, function (it, index) {
            // 销毁
            if (is_array_1.default(it)) {
                _this.chart.filter(it[0], null);
            }
            else {
                _this.chart.filter(index, null);
            }
        });
        each_1.default(newConfig.filter, function (it, index) {
            if (is_array_1.default(it)) {
                _this.chart.filter(it[0], it[1]);
            }
            else {
                _this.chart.filter(index, it);
            }
        });
        // 主题
        this.chart.theme(newConfig.theme);
        // 缓存处理后的配置
        this.config = newConfig;
    };
    ChartHelper.prototype.adapterOptions = function (_a) {
        var data = _a.data, others = __rest(_a, ["data"]);
        // 剔除 React 自身的属性
        var options = pickWithout_1.default(others, __spreadArrays(constant_1.REACT_PIVATE_PROPS));
        if (options.forceFit) {
            warning_1.default(false, 'forceFit 已废弃，请使用`autoFit`替代');
        }
        options.data = processData(data) || [];
        return options;
    };
    ChartHelper.prototype.destory = function () {
        if (!this.chart) {
            return;
        }
        this.extendGroup = null;
        var chart = this.chart;
        chart.destroy();
        chart = null;
        this.chart = null;
        this.config = {};
    };
    return ChartHelper;
}(event_emitter_1.default));
exports["default"] = ChartHelper;
//# sourceMappingURL=chartHelper.js.map

/***/ }),

/***/ 20370:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TOOLTIP_EVENT = exports.ANNOTATION_EVENT_TARGET = exports.AXIS_EVENT_TARGET = exports.LEGEND_EVENT = exports.GEOM_NAME = exports.LEGEND_EVENT_TARGETS = exports.LIFE_CIRCLE_NAMES = exports.MOBILE_EVENT_NAMES = exports.DRAG_EVENT_NAMES = exports.pickEventName = exports.BASE_EVENT_NAMES = void 0;
// /[^on]+\S+(?=(Click)\b)/
var for_in_1 = __importDefault(__webpack_require__(8361));
exports.BASE_EVENT_NAMES = [
    'mousedown',
    'mouseup',
    'dblclick',
    'mouseenter',
    'mouseout',
    'mouseover',
    'mousemove',
    'mouseleave',
    'contextmenu',
    'click',
];
var EVENT_ACTION_NAMES = [
    'mousedown',
    'mouseup',
    'dblclick',
    'mouseenter',
    'mouseout',
    'mouseover',
    'mousemove',
    'mouseleave',
    'contextmenu',
    'click',
    'show',
    'hide',
    'change',
];
var RegExpEvent = new RegExp("^on(.*)(?=(" + EVENT_ACTION_NAMES.map(function (k) { return k.replace(/^\S/, function (s) { return s.toUpperCase(); }); }).join('|') + "))");
exports.pickEventName = function (props) {
    var names = [];
    for_in_1.default(props, function (v, k) {
        var event = k.match(/^on(.*)/);
        if (event) {
            var res = k.match(RegExpEvent);
            if (res) {
                var target = res[1].replace(/([A-Z])/g, "-$1").toLowerCase();
                if (target) {
                    names.push([k, target.replace('-', '') + ":" + res[2].toLowerCase()]);
                }
                else {
                    names.push([k, res[2].toLowerCase()]);
                }
            }
            else {
                names.push([k, event[1].toLowerCase()]);
            }
        }
    });
    return names;
};
exports.DRAG_EVENT_NAMES = [
    'dragstart',
    'drag',
    'dragend',
    'dragover',
    'dragenter',
    'dragleave',
    'drop'
];
exports.MOBILE_EVENT_NAMES = [
    'touchstart',
    'touchmove',
    'touchend',
];
exports.LIFE_CIRCLE_NAMES = [
    'beforerender',
    'afterrender',
    'beforepaint',
    'afterpaint',
    'beforechangedata',
    'afterchangedata',
    'beforeclear',
    'afterclear',
    'beforedestroy',
];
exports.LEGEND_EVENT_TARGETS = [
    'legend',
    'legend-title',
    'legend-item',
    'legend-item-name',
    'legend-item-Maker',
    'legend-item-value',
];
exports.GEOM_NAME = [
    'line',
    'area',
    'point',
    'interval',
    'polygon',
    'edge',
    'schema'
];
exports.LEGEND_EVENT = ['legend:valuechanged'];
exports.AXIS_EVENT_TARGET = [
    'axis-label',
    'axis-line',
    'axis-tick',
    'axis-title',
];
exports.ANNOTATION_EVENT_TARGET = [
    'annotation',
    'annotation-line',
    'annotation-line-text',
    'annotation-image',
    'annotation-region',
    'annotation-text',
];
exports.TOOLTIP_EVENT = [
    'tooltip:show',
    'tooltip:hide',
    'tooltip:change',
];
//# sourceMappingURL=events.js.map

/***/ }),

/***/ 9345:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Chart = void 0;
var react_1 = __importDefault(__webpack_require__(67294));
var debounce_1 = __importDefault(__webpack_require__(79663));
var dom_1 = __webpack_require__(93721);
var resize_observer_1 = __webpack_require__(58354);
var ErrorBoundary_1 = __importStar(__webpack_require__(7245));
var withContainer_1 = __importDefault(__webpack_require__(377));
var root_1 = __importDefault(__webpack_require__(62059));
var view_1 = __importDefault(__webpack_require__(14244));
var group_1 = __importDefault(__webpack_require__(57743));
var chartHelper_1 = __importDefault(__webpack_require__(29182));
var util_1 = __webpack_require__(13810);
var Chart = /** @class */ (function (_super) {
    __extends(Chart, _super);
    function Chart(props) {
        var _this = _super.call(this, props) || this;
        _this.isRootView = true;
        _this.resize = debounce_1.default(function () {
            var chart = _this.chartHelper.chart;
            if (_this.props.autoFit && _this.chartHelper.chart) {
                var _a = dom_1.getChartSize(_this.props.container, _this.props.autoFit, chart.width, chart.height), width = _a.width, height = _a.height;
                if (chart.width !== width || chart.height !== height) {
                    chart.changeSize(width, height);
                    chart.emit('resize');
                }
            }
        }, 300);
        // 监听容器发生resize
        _this.resizeObserver = new resize_observer_1.ResizeObserver(_this.resize);
        _this.resizeObserver.observe(props.container);
        _this.chartHelper = new chartHelper_1.default();
        return _this;
    }
    Chart.prototype.componentDidMount = function () {
        if (this.isError) {
            this.chartHelper.destory();
        }
        else {
            this.chartHelper.render();
        }
    };
    Chart.prototype.componentDidUpdate = function () {
        if (this.isError) {
            this.chartHelper.destory();
            return;
        }
        // 更新图表大小
        var _a = this.props, width = _a.width, height = _a.height, autoFit = _a.autoFit;
        // 已经自适应就不更新大小了
        if (!autoFit && this.chartHelper.chart) {
            if ((width >= 0 && width !== this.chartHelper.chart.width) ||
                (height >= 0 && height !== this.chartHelper.chart.height)) {
                var nextWidth = width || this.chartHelper.chart.width;
                var nextHeight = height || this.chartHelper.chart.height;
                // changeSize方法内部有调用render, 自动更新无需
                this.chartHelper.chart.changeSize(nextWidth, nextHeight);
                this.chartHelper.chart.emit('resize');
            }
            else {
                this.chartHelper.render();
            }
        }
        else {
            this.chartHelper.render();
        }
    };
    Chart.prototype.componentWillUnmount = function () {
        this.chartHelper.destory();
        this.resizeObserver.unobserve(this.props.container);
    };
    // 外部通过ref调用获取实例
    Chart.prototype.getG2Instance = function () {
        return this.chartHelper.chart;
    };
    Chart.prototype.render = function () {
        var _this = this;
        var _a = this.props, placeholder = _a.placeholder, data = _a.data, errorContent = _a.errorContent;
        var ErrorBoundaryProps = this.props.ErrorBoundaryProps;
        if ((data === undefined || data.length === 0) && placeholder) {
            this.chartHelper.destory();
            var pl = placeholder === true ? react_1.default.createElement("div", { style: { position: 'relative', top: '48%', color: '#aaa', textAlign: 'center' } }, "\u6682\u65E0\u6570\u636E") : placeholder;
            return react_1.default.createElement(ErrorBoundary_1.default, __assign({}, ErrorBoundaryProps), pl);
        }
        this.chartHelper.update(this.props);
        if (errorContent) {
            // 兼容 4.0 的用法
            ErrorBoundaryProps = __assign({ fallback: errorContent }, ErrorBoundaryProps);
        }
        else {
            // react-ErrorBoundary
            ErrorBoundaryProps = {
                FallbackComponent: ErrorBoundary_1.ErrorFallback
            };
        }
        return (react_1.default.createElement(ErrorBoundary_1.default, __assign({}, ErrorBoundaryProps, { key: this.chartHelper.key, onError: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isError = true;
                util_1.isFunction(ErrorBoundaryProps.onError) && ErrorBoundaryProps.onError.apply(ErrorBoundaryProps, args);
            }, onReset: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                _this.isError = false;
                util_1.isFunction(ErrorBoundaryProps.onReset) && ErrorBoundaryProps.onReset.apply(ErrorBoundaryProps, args);
            }, resetKeys: [this.chartHelper.key], fallback: errorContent }),
            react_1.default.createElement(root_1.default.Provider, { value: this.chartHelper },
                react_1.default.createElement(view_1.default.Provider, { value: this.chartHelper.chart },
                    react_1.default.createElement(group_1.default.Provider, { value: this.chartHelper.extendGroup }, this.props.children)))));
    };
    Chart.defaultProps = {
        placeholder: false,
        visible: true,
        interactions: [],
        filter: [],
    };
    return Chart;
}(react_1.default.Component));
exports.Chart = Chart;
exports["default"] = withContainer_1.default(Chart);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 80145:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(67294));
var react_dom_1 = __importDefault(__webpack_require__(73935));
var get_1 = __importDefault(__webpack_require__(58070));
var modify_css_1 = __importDefault(__webpack_require__(1513));
var view_1 = __webpack_require__(14244);
var core_1 = __webpack_require__(88009);
var CONTAINER_CLASS = 'g2-tooltip';
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderInnder = function (e) {
            var _a = e.data, title = _a.title, items = _a.items, x = _a.x, y = _a.y;
            // 当数据变化的时候渲染, todo: 新建fiber根节点，和react虚拟dom的性能对比报告
            react_dom_1.default.render(_this.props.children(title, items, x, y, e), _this.getElement());
        };
        return _this;
    }
    Tooltip.prototype.componentWillUnmount = function () {
        var chartView = this.props.chartView;
        if (this.element) {
            this.element.remove();
        }
        chartView.getController('tooltip').clear();
        chartView.off('tooltip:change', this.renderInnder);
    };
    Tooltip.prototype.getElement = function () {
        if (!this.element) {
            this.element = document.createElement('div');
            this.element.classList.add('bizcharts-tooltip');
            this.element.classList.add('g2-tooltip');
            this.element.style.width = 'auto';
            this.element.style.height = 'auto';
        }
        return this.element;
    };
    Tooltip.prototype.overwriteCfg = function () {
        var _this = this;
        var _a = this.props, chartView = _a.chartView, children = _a.children, _b = _a.domStyles, domStyles = _b === void 0 ? {} : _b, config = __rest(_a, ["chartView", "children", "domStyles"]);
        chartView.tooltip(__assign(__assign({ inPlot: false, domStyles: domStyles }, config), { 
            // 坐标移动即渲染
            customContent: function () { return _this.getElement(); } }));
        chartView.on('tooltip:change', this.renderInnder);
        // fixme: 主题要去图表主题，要meger domStyle。
        var domStylesTheme = get_1.default(core_1.getTheme(), ['components', 'tooltip', 'domStyles', CONTAINER_CLASS], {});
        modify_css_1.default(this.element, __assign(__assign({}, domStylesTheme), domStyles[CONTAINER_CLASS]));
    };
    Tooltip.prototype.render = function () {
        this.overwriteCfg();
        return null; // 无子组件
    };
    return Tooltip;
}(react_1.default.Component));
exports["default"] = view_1.withView(Tooltip);
//# sourceMappingURL=ReactTooltip.js.map

/***/ }),

/***/ 46833:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var active_region_1 = __importDefault(__webpack_require__(34287));
var sibling_1 = __importDefault(__webpack_require__(96842));
var geometry_1 = __importDefault(__webpack_require__(45522));
var ellipsis_text_1 = __importDefault(__webpack_require__(78757));
var core_1 = __webpack_require__(88009);
core_1.registerAction('tooltip', geometry_1.default);
core_1.registerAction('sibling-tooltip', sibling_1.default);
core_1.registerAction('active-region', active_region_1.default);
core_1.registerAction('ellipsis-text', ellipsis_text_1.default);
// 注册 tooltip 的 interaction
core_1.registerInteraction('tooltip', {
    start: [
        { trigger: 'plot:mousemove', action: 'tooltip:show', throttle: { wait: 50, leading: true, trailing: false } },
        { trigger: 'plot:touchmove', action: 'tooltip:show', throttle: { wait: 50, leading: true, trailing: false } },
    ],
    end: [
        { trigger: 'plot:mouseleave', action: 'tooltip:hide' },
        { trigger: 'plot:leave', action: 'tooltip:hide' },
        { trigger: 'plot:touchend', action: 'tooltip:hide' },
    ],
});
core_1.registerInteraction('ellipsis-text', {
    start: [
        {
            trigger: 'legend-item-name:mousemove',
            action: 'ellipsis-text:show',
            throttle: { wait: 50, leading: true, trailing: false },
        },
        {
            trigger: 'legend-item-name:touchstart',
            action: 'ellipsis-text:show',
            throttle: { wait: 50, leading: true, trailing: false },
        },
        {
            trigger: 'axis-label:mousemove',
            action: 'ellipsis-text:show',
            throttle: { wait: 50, leading: true, trailing: false },
        },
        {
            trigger: 'axis-label:touchstart',
            action: 'ellipsis-text:show',
            throttle: { wait: 50, leading: true, trailing: false },
        },
    ],
    end: [
        { trigger: 'legend-item-name:mouseleave', action: 'ellipsis-text:hide' },
        { trigger: 'legend-item-name:touchend', action: 'ellipsis-text:hide' },
        { trigger: 'axis-label:mouseleave', action: 'ellipsis-text:hide' },
        { trigger: 'axis-label:touchend', action: 'ellipsis-text:hide' },
    ],
});
// click 触发
core_1.registerInteraction('tooltip-click', {
    start: [
        { trigger: 'plot:click', action: 'tooltip:show', throttle: { wait: 50, leading: true, trailing: false } },
        { trigger: 'plot:touchstart', action: 'tooltip:show', throttle: { wait: 50, leading: true, trailing: false } },
    ],
    end: [
        { trigger: 'plot:leave', action: 'tooltip:hide' },
    ],
});
// tooltip 跟随和不跟随之间切换
var toggleLock = function (context) {
    var locked = context.view.isTooltipLocked();
    if (locked) {
        context.view.unlockTooltip();
    }
    else {
        context.view.lockTooltip();
    }
};
core_1.registerInteraction('tooltip-lock', {
    start: [
        { trigger: 'plot:click', action: toggleLock },
        { trigger: 'plot:touchstart', action: toggleLock },
        { trigger: 'plot:touchmove', action: 'tooltip:show', throttle: { wait: 50, leading: true, trailing: false } },
        { trigger: 'plot:mousemove', action: 'tooltip:show' },
    ],
    end: [
        { trigger: 'plot:click', action: 'tooltip:hide' },
        { trigger: 'plot:leave', action: 'tooltip:hide' },
        { trigger: 'plot:touchend', action: 'tooltip:hide' },
    ],
});
// 注册 sibling-tooltip 的 interaction
core_1.registerInteraction('sibling-tooltip', {
    start: [{ trigger: 'plot:mousemove', action: 'sibling-tooltip:show' }],
    end: [{ trigger: 'plot:mouseleave', action: 'sibling-tooltip:hide' }],
});
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ 68325:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importStar(__webpack_require__(67294));
var is_function_1 = __importDefault(__webpack_require__(46812));
var tooltip_1 = __importDefault(__webpack_require__(64815));
var unique_id_1 = __importDefault(__webpack_require__(67250));
var is_array_1 = __importDefault(__webpack_require__(66631));
var is_string_1 = __importDefault(__webpack_require__(21830));
var core_1 = __webpack_require__(88009);
var useChartView_1 = __importDefault(__webpack_require__(45950));
var ReactTooltip_1 = __importDefault(__webpack_require__(80145));
var createTooltipConnector_1 = __webpack_require__(99783);
__webpack_require__(46833);
core_1.registerComponentController('tooltip', tooltip_1.default);
var isReactTooltip = function (props) {
    var _a = props.visible, visible = _a === void 0 ? true : _a, children = props.children;
    return visible && is_function_1.default(children);
};
var TooltipNormal = function (props) {
    var _a = props.visible, visible = _a === void 0 ? true : _a, children = props.children, options = __rest(props, ["visible", "children"]);
    var chartView = useChartView_1.default();
    chartView.getController('tooltip').clear();
    if (visible === true) {
        chartView.tooltip(__assign({ customContent: null, showMarkers: false }, options));
    }
    else {
        chartView.tooltip(false);
    }
    return null;
};
function Tooltip(props) {
    var children = props.children, triggerOn = props.triggerOn, onShow = props.onShow, onChange = props.onChange, onHide = props.onHide, lock = props.lock, linkage = props.linkage, options = __rest(props, ["children", "triggerOn", "onShow", "onChange", "onHide", "lock", "linkage"]);
    var chartView = useChartView_1.default();
    chartView.removeInteraction('tooltip');
    chartView.removeInteraction('tooltip-click');
    chartView.removeInteraction('tooltip-lock');
    if (triggerOn === 'click') {
        // 只有click的时候才会出现tooltip，hover 无效
        chartView.interaction("tooltip-click");
    }
    else if (lock) {
        // hover的时候触发，但是点击的时候锁定位置
        chartView.interaction("tooltip-lock");
    }
    else {
        // click不会有任何动作，只有hover的时候跟随
        chartView.interaction("tooltip");
    }
    var connectorId = react_1.useRef(unique_id_1.default('tooltip'));
    // tooltip 联动
    react_1.useEffect(function () {
        if (is_array_1.default(linkage)) {
            createTooltipConnector_1.registerConnector(linkage[0], connectorId.current, chartView, options.shared, linkage[1]);
        }
        else if (is_string_1.default(linkage)) {
            createTooltipConnector_1.registerConnector(linkage, connectorId.current, chartView, options.shared);
        }
    }, [linkage, chartView]);
    var showFnc = react_1.useCallback(function (ITooltipEvent) {
        if (is_function_1.default(onShow)) {
            onShow(ITooltipEvent, chartView);
        }
    }, []);
    var changeFnc = react_1.useCallback(function (ITooltipEvent) {
        if (is_function_1.default(onChange)) {
            onChange(ITooltipEvent, chartView);
        }
    }, []);
    var hideFnc = react_1.useCallback(function (ITooltipEvent) {
        if (is_function_1.default(onHide)) {
            onHide(ITooltipEvent, chartView);
        }
    }, []);
    chartView.off('tooltip:show', showFnc);
    chartView.on('tooltip:show', showFnc);
    chartView.off('tooltip:change', changeFnc);
    chartView.on('tooltip:change', changeFnc);
    chartView.off('tooltip:hide', hideFnc);
    chartView.on('tooltip:hide', hideFnc);
    return isReactTooltip(props) ? react_1.default.createElement(ReactTooltip_1.default, __assign({}, options), children) : react_1.default.createElement(TooltipNormal, __assign({}, props));
}
exports["default"] = Tooltip;
Tooltip.defaultProps = {
    showMarkers: false,
    triggerOn: 'hover',
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 99783:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.registerConnector = exports.Connector = void 0;
// todo: 图表联动方案
var register_1 = __webpack_require__(93359);
var geometry_1 = __importDefault(__webpack_require__(45522));
var util_1 = __webpack_require__(13810);
var core_1 = __webpack_require__(88009);
var CONNECTOR_MAP = {};
var Connector = /** @class */ (function () {
    function Connector(type) {
        this.cfg = { shared: true };
        this.chartMap = {};
        this.state = {};
        this.id = util_1.uniqueId('bx-action');
        this.type = type || 'tooltip';
    }
    Connector.prototype.connect = function (id, chart, pointFinder) {
        this.chartMap[id] = { chart: chart, pointFinder: pointFinder };
        chart.interaction("connect-" + this.type + "-" + this.id);
        if (this.type === 'tooltip' && this.cfg.shared) {
            if (util_1.get(chart, ['options', 'tooltip', 'shared']) === undefined) {
                util_1.set(chart, ['options', 'tooltip', 'shared'], true);
            }
            ;
        }
        return this;
    };
    Connector.prototype.unConnect = function (id) {
        this.chartMap[id].chart.removeInteraction("connect-" + this.type + "-" + this.id);
        delete this.chartMap[id];
    };
    Connector.prototype.destroy = function () {
        register_1.unregisterAction("connect-" + this.type + "-" + this.id);
    };
    return Connector;
}());
exports.Connector = Connector;
// 关联图表何处触发tooltip
var createTooltipConnector = function () {
    var cm = new Connector('tooltip');
    core_1.registerAction("connect-tooltip-" + cm.id, /** @class */ (function (_super) {
        __extends(ConnectTooltip, _super);
        function ConnectTooltip() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.CM = cm;
            return _this;
        }
        ConnectTooltip.prototype.showTooltip = function (view, point) {
            var records = view.getTooltipItems(point) || point;
            util_1.forIn(this.CM.chartMap, function (item) {
                var chart = item.chart, pointFinder = item.pointFinder;
                if (chart.destroyed || !chart.visible) {
                    return;
                }
                if (pointFinder) {
                    var triggerPoint = pointFinder(records, chart);
                    // 如果没有返回值，则不联动
                    if (triggerPoint) {
                        chart.showTooltip(triggerPoint);
                    }
                    ;
                }
                else {
                    chart.showTooltip(point);
                }
            });
        };
        ConnectTooltip.prototype.hideTooltip = function () {
            util_1.forIn(this.CM.chartMap, function (_a) {
                var chart = _a.chart;
                return chart.hideTooltip();
            });
        };
        return ConnectTooltip;
    }(geometry_1.default)));
    core_1.registerInteraction("connect-tooltip-" + cm.id, {
        start: [{ trigger: 'plot:mousemove', action: "connect-tooltip-" + cm.id + ":show" }],
        end: [{ trigger: 'plot:mouseleave', action: "connect-tooltip-" + cm.id + ":hide" }],
    });
    return cm;
};
exports.registerConnector = function (cid, tid, chart, shared, pointFinder) {
    var connector = CONNECTOR_MAP[cid];
    // 销毁
    if (chart === null && connector) {
        connector.unConnect(tid);
        return;
    }
    // 创建 & 注册
    if (connector) {
        connector.connect(tid, chart, pointFinder);
    }
    else {
        CONNECTOR_MAP[cid] = createTooltipConnector();
        // shared false 是为了兼容饼图不支持shared的tooltip
        CONNECTOR_MAP[cid].cfg.shared = !!shared;
        CONNECTOR_MAP[cid].connect(tid, chart, pointFinder);
    }
};
exports["default"] = createTooltipConnector;
//# sourceMappingURL=createTooltipConnector.js.map

/***/ }),

/***/ 57743:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withGroupContext = void 0;
var react_1 = __importDefault(__webpack_require__(67294));
// Group 实例透传
var GroupContext = react_1.default.createContext(null);
GroupContext.displayName = 'GroupContext';
function withGroupContext(Component) {
    var Com = react_1.default.forwardRef(function (props, ref) {
        return (react_1.default.createElement(GroupContext.Consumer, null, function (ctx) { return react_1.default.createElement(Component, __assign({ ref: ref, group: ctx }, props)); }));
    });
    Com.displayName = Component.name;
    return Com;
}
exports.withGroupContext = withGroupContext;
;
exports["default"] = GroupContext;
//# sourceMappingURL=group.js.map

/***/ }),

/***/ 62059:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withChartInstance = void 0;
var react_1 = __importDefault(__webpack_require__(67294));
// 最顶层chart实例 theme, 局部配置
var RootChartContext = react_1.default.createContext(null);
RootChartContext.displayName = 'RootChartContext';
function withChartInstance(Component) {
    var Com = react_1.default.forwardRef(function (props, ref) {
        return (react_1.default.createElement(RootChartContext.Consumer, null, function (ctx) { return react_1.default.createElement(Component, __assign({ ref: ref }, ctx, props)); }));
    });
    Com.displayName = Component.name;
    return Com;
}
exports.withChartInstance = withChartInstance;
;
exports["default"] = RootChartContext;
//# sourceMappingURL=root.js.map

/***/ }),

/***/ 14244:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.withView = void 0;
var react_1 = __importDefault(__webpack_require__(67294));
// 父级图层实例，chart 或者 view
var ChartViewContext = react_1.default.createContext(null);
ChartViewContext.displayName = 'ChartViewContext';
var Consumer = ChartViewContext.Consumer;
function withView(Component) {
    return function (props) {
        return react_1.default.createElement(Consumer, null, function (ctx) { return react_1.default.createElement(Component, __assign({ chartView: ctx }, props)); });
    };
}
exports.withView = withView;
exports["default"] = ChartViewContext;
//# sourceMappingURL=view.js.map

/***/ }),

/***/ 88009:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.VERSION = void 0;
// 注册 G 渲染引擎
var CanvasEngine = __importStar(__webpack_require__(78126));
var SVGEngine = __importStar(__webpack_require__(56225));
var core_1 = __webpack_require__(85096);
// 导出自定义比例尺的能力
var scale_1 = __webpack_require__(33395);
Object.defineProperty(exports, "registerScale", ({ enumerable: true, get: function () { return scale_1.registerScale; } }));
Object.defineProperty(exports, "getScale", ({ enumerable: true, get: function () { return scale_1.getScale; } }));
Object.defineProperty(exports, "registerTickMethod", ({ enumerable: true, get: function () { return scale_1.registerTickMethod; } }));
var global_1 = __webpack_require__(33855);
Object.defineProperty(exports, "setGlobal", ({ enumerable: true, get: function () { return global_1.setGlobal; } }));
Object.defineProperty(exports, "GLOBAL", ({ enumerable: true, get: function () { return global_1.GLOBAL; } }));
__webpack_require__(35686);
// 动画
__webpack_require__(5199);
// 主题
__exportStar(__webpack_require__(95413), exports);
core_1.registerEngine('canvas', CanvasEngine);
core_1.registerEngine('svg', SVGEngine);
// @ts-ignore
__exportStar(__webpack_require__(85096), exports);
exports.VERSION = '4.1.14';
// fixme: supportCSSTransform 在g2@4.1.0 后支持
// 原始的计算坐标方法
var rawGetPointByClient = CanvasEngine.Canvas.prototype.getPointByClient;
CanvasEngine.Canvas.prototype.getPointByClient = function (clientX, clientY) {
    // 获取原函数返回的坐标值
    var raw = rawGetPointByClient.call(this, clientX, clientY);
    // 获取设定高宽和真实高宽。
    // 当设定的高宽不等于getBoundingClientRect获取的高宽时，说明存在缩放。
    var el = this.get('el');
    var bbox = el.getBoundingClientRect();
    var setWidth = this.get('width');
    var setHeight = this.get('height');
    var realWidth = bbox.width, realHeight = bbox.height;
    // 除以缩放比（真实高宽 / 设定高宽）获得真实的坐标。
    return {
        x: raw.x / (realWidth / setWidth),
        y: raw.y / (realHeight / setHeight),
    };
};
// 设置全局默认的error fallback
var ErrorBoundary_1 = __webpack_require__(7245);
Object.defineProperty(exports, "setDefaultErrorFallback", ({ enumerable: true, get: function () { return ErrorBoundary_1.setDefaultErrorFallback; } }));
//# sourceMappingURL=core.js.map

/***/ }),

/***/ 9523:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
// 认为是nice的刻度
var SNAP_COUNT_ARRAY = [1, 1.2, 1.5, 2, 2.2, 2.4, 2.5, 3, 4, 5, 6, 7.5, 8, 10];
var DEFAULT_COUNT = 5; // 默认刻度值
exports["default"] = (function (cfg) {
    var _a = cfg || {}, tickCount = _a.tickCount, tickInterval = _a.tickInterval;
    var _b = cfg || {}, min = _b.min, max = _b.max;
    min = isNaN(min) ? 0 : min;
    max = isNaN(max) ? 0 : max;
    var count = tickCount && tickCount >= 2 ? tickCount : DEFAULT_COUNT;
    // 计算interval， 优先取tickInterval
    var interval = tickInterval || getBestInterval({ tickCount: count, max: max, min: min });
    // 通过interval计算最小tick
    var minTick = Math.floor(min / interval) * interval;
    // 如果指定了tickInterval, count 需要根据指定的tickInterval来算计
    if (tickInterval) {
        var intervalCount = Math.abs(Math.ceil((max - minTick) / tickInterval)) + 1;
        // tickCount 作为最小 count 处理
        count = Math.max(count, intervalCount);
    }
    var ticks = [];
    var tickLength = 0;
    var fixedLength = getFixedLength(interval);
    while (tickLength < count) {
        ticks.push(toFixed(minTick + tickLength * interval, fixedLength));
        tickLength++;
    }
    return ticks;
});
var DECIMAL_LENGTH = 12;
function getFactor(number) {
    // 取正数
    number = Math.abs(number);
    var factor = 1;
    if (number === 0) {
        return factor;
    }
    // 小于1,逐渐放大
    if (number < 1) {
        var count = 0;
        while (number < 1) {
            factor = factor / 10;
            number = number * 10;
            count++;
        }
        // 浮点数计算出现问题
        if (factor.toString().length > DECIMAL_LENGTH) {
            factor = parseFloat(factor.toFixed(count));
        }
        return factor;
    }
    // 大于10逐渐缩小
    while (number > 10) {
        factor = factor * 10;
        number = number / 10;
    }
    return factor;
}
// 获取最佳匹配刻度
function getBestInterval(_a) {
    var tickCount = _a.tickCount, min = _a.min, max = _a.max;
    // 如果最大最小相等，则直接按1处理
    if (min === max) {
        return 1 * getFactor(max);
    }
    // 1.计算平均刻度间隔
    var avgInterval = (max - min) / (tickCount - 1);
    // 2.数据标准归一化 映射到[1-10]区间
    var factor = getFactor(avgInterval);
    var calInterval = avgInterval / factor;
    var calMax = max / factor;
    var calMin = min / factor;
    // 根据平均值推算最逼近刻度值
    var similarityIndex = 0;
    for (var index = 0; index < SNAP_COUNT_ARRAY.length; index++) {
        var item = SNAP_COUNT_ARRAY[index];
        if (calInterval <= item) {
            similarityIndex = index;
            break;
        }
    }
    var similarityInterval = getInterval(similarityIndex, tickCount, calMin, calMax);
    // 小数点位数还原到数据的位数, 因为similarityIndex有可能是小数，所以需要保留similarityIndex自己的小数位数
    var fixedLength = getFixedLength(similarityInterval) + getFixedLength(factor);
    return toFixed(similarityInterval * factor, fixedLength);
}
function getInterval(startIndex, tickCount, min, max) {
    var verify = false;
    var interval = SNAP_COUNT_ARRAY[startIndex];
    // 刻度值校验，如果不满足，循环下去
    for (var i = startIndex; i < SNAP_COUNT_ARRAY.length; i++) {
        if (intervalIsVerify({ interval: SNAP_COUNT_ARRAY[i], tickCount: tickCount, max: max, min: min })) {
            // 有符合条件的interval
            interval = SNAP_COUNT_ARRAY[i];
            verify = true;
            break;
        }
    }
    // 如果不满足, 依次缩小10倍，再计算
    if (!verify) {
        return 10 * getInterval(0, tickCount, min / 10, max / 10);
    }
    return interval;
}
// 刻度是否满足展示需求
function intervalIsVerify(_a) {
    var interval = _a.interval, tickCount = _a.tickCount, max = _a.max, min = _a.min;
    var minTick = Math.floor(min / interval) * interval;
    if (minTick + (tickCount - 1) * interval >= max) {
        return true;
    }
    return false;
}
// 计算小数点应该保留的位数
function getFixedLength(num) {
    var str = num.toString();
    var index = str.indexOf('.');
    var indexOfExp = str.indexOf('e-');
    var length = indexOfExp >= 0 ? parseInt(str.substr(indexOfExp + 2), 10) : str.substr(index + 1).length;
    if (length > 20) {
        // 最多保留20位小数
        length = 20;
    }
    return length;
}
// @antv/util fixedbase不支持科学计数法的判断，需要提mr
function toFixed(v, length) {
    return parseFloat(v.toFixed(length));
}
//# sourceMappingURL=linear-tick.js.map

/***/ }),

/***/ 35686:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var scale_1 = __webpack_require__(33395);
var linear_tick_1 = __importDefault(__webpack_require__(9523));
scale_1.registerTickMethod('linear-strict-tick-method', linear_tick_1.default);
/**
 * 线性度量
 * @class
 */
var LinearStrict = /** @class */ (function (_super) {
    __extends(LinearStrict, _super);
    function LinearStrict(props) {
        var _this = _super.call(this, props) || this;
        _this.type = 'linear-strict';
        return _this;
    }
    LinearStrict.prototype.initCfg = function () {
        _super.prototype.initCfg.call(this);
        this.tickMethod = 'linear-strict-tick-method';
    };
    LinearStrict.prototype.calculateTicks = function () {
        var preNice = this.nice;
        // 强制按照计算出来的ticks，需要设置nice为true，不然会根据最值进行过滤
        this.nice = true;
        var ticks = _super.prototype.calculateTicks.call(this);
        this.nice = preNice;
        // 根据ticks设置最值
        if (ticks.length) {
            this.min = ticks[0];
            this.max = ticks[ticks.length - 1];
        }
        return ticks;
    };
    return LinearStrict;
}(scale_1.Linear));
exports["default"] = LinearStrict;
if (!scale_1.getScale('linear-strict')) {
    scale_1.registerScale('linear-strict', LinearStrict);
}
//# sourceMappingURL=scale.js.map

/***/ }),

/***/ 51522:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var area_1 = __importDefault(__webpack_require__(64658));
var Base_1 = __importDefault(__webpack_require__(60411));
var core_1 = __webpack_require__(88009);
__webpack_require__(65082);
core_1.registerGeometry('Area', area_1.default);
var AreaGeom = /** @class */ (function (_super) {
    __extends(AreaGeom, _super);
    function AreaGeom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GemoBaseClassName = 'area';
        return _this;
    }
    return AreaGeom;
}(Base_1.default));
exports["default"] = AreaGeom;
//# sourceMappingURL=Area.js.map

/***/ }),

/***/ 60411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(67294));
var is_string_1 = __importDefault(__webpack_require__(21830));
var is_function_1 = __importDefault(__webpack_require__(46812));
var base_1 = __importDefault(__webpack_require__(91646));
var view_1 = __importDefault(__webpack_require__(14244));
var core_1 = __webpack_require__(88009);
var compareProps_1 = __importDefault(__webpack_require__(75665));
var warning_1 = __importDefault(__webpack_require__(42473));
__webpack_require__(91272);
// 交互事件
__webpack_require__(81426);
var cloneDeep_1 = __importDefault(__webpack_require__(56956));
core_1.registerGeometryLabel('base', base_1.default);
var DEFAULT_SORT_GEOMETRYS = ['line', 'area'];
var GeomHelper = /** @class */ (function () {
    function GeomHelper() {
        this.config = {};
    }
    GeomHelper.prototype.setView = function (view) {
        this.view = view;
        this.rootChart = view.rootChart || view; // 顶层chart实例
    };
    GeomHelper.prototype.createGeomInstance = function (GemoBaseClassName, cfg) {
        this.geom = this.view[GemoBaseClassName](cfg);
        var sortable = cfg.sortable;
        // 复写原型
        // @ts-ignore
        this.geom.__beforeMapping = this.geom.beforeMapping;
        // @ts-ignore
        this.geom.beforeMapping = function (data) {
            var xScale = this.getXScale();
            if (sortable !== false && data && data[0] && DEFAULT_SORT_GEOMETRYS.includes(GemoBaseClassName) && ['time', 'timeCat'].includes(xScale.type)) {
                this.sort(data);
            }
            return this.__beforeMapping(data);
        };
        this.GemoBaseClassName = GemoBaseClassName;
    };
    GeomHelper.prototype.update = function (newConfig, component) {
        var _this = this;
        if (!this.geom) {
            this.setView(component.context);
            // 如果是时间类型则对数据排序
            this.createGeomInstance(component.GemoBaseClassName, newConfig);
            this.interactionTypes = component.interactionTypes;
        }
        compareProps_1.default(this.config, newConfig, ['position', 'shape', 'color', 'label', 'style', 'tooltip', 'size', 'animate', 'state', 'customInfo'], function (value, key) {
            var _a;
            // value 已被转为array
            warning_1.default(!(key === 'label' && value[0] === true), 'label 值类型错误，应为false | LabelOption | FieldString');
            (_a = _this.geom)[key].apply(_a, value);
        });
        compareProps_1.default(this.config, newConfig, ['adjust'], function (value, key) {
            if (is_string_1.default(value[0])) {
                _this.geom[key](value[0]);
            }
            else {
                _this.geom[key](value);
            }
        });
        // 状态设置
        this.geom.state(newConfig.state || {});
        // selected 和 active 使用 interacttion 替代
        // setElements 设置 selected 和 active 默认值
        this.rootChart.on('processElemens', function () {
            if (is_function_1.default(newConfig.setElements)) {
                newConfig.setElements(_this.geom.elements);
            }
        });
        // 交互
        // interaction 
        compareProps_1.default(this.config, newConfig, this.interactionTypes, function (value, key) {
            if (value[0]) {
                _this.rootChart.interaction(key);
            }
            else {
                _this.rootChart.removeInteraction(key);
            }
        });
        // 缓存
        this.config = cloneDeep_1.default(newConfig);
    };
    GeomHelper.prototype.destroy = function () {
        if (this.geom) {
            this.geom.destroy();
            this.geom = null;
        }
        this.config = {};
    };
    return GeomHelper;
}());
var BaseGeom = /** @class */ (function (_super) {
    __extends(BaseGeom, _super);
    function BaseGeom(props) {
        var _this = _super.call(this, props) || this;
        _this.interactionTypes = [];
        _this.geomHelper = new GeomHelper();
        return _this;
    }
    BaseGeom.prototype.componentWillUnmount = function () {
        this.geomHelper.destroy();
    };
    BaseGeom.prototype.render = function () {
        var _this = this;
        this.geomHelper.update(this.props, this);
        return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.Children.map(this.props.children, function (ele) {
            return react_1.default.isValidElement(ele) ? react_1.default.cloneElement(ele, { parentInstance: _this.geomHelper.geom }) : react_1.default.createElement(react_1.default.Fragment, null);
        }));
    };
    return BaseGeom;
}(react_1.default.Component));
BaseGeom.contextType = view_1.default;
exports["default"] = BaseGeom;
//# sourceMappingURL=Base.js.map

/***/ }),

/***/ 91272:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(67294));
// 注册 Geometry 内置的 label
var base_1 = __importDefault(__webpack_require__(91646));
var interval_1 = __importDefault(__webpack_require__(31956));
var pie_1 = __importDefault(__webpack_require__(39935));
var polar_1 = __importDefault(__webpack_require__(31775));
// 注册 Geometry label 内置的布局函数
var distribute_1 = __webpack_require__(58588);
var limit_in_canvas_1 = __webpack_require__(83213);
var limit_in_shape_1 = __webpack_require__(67202);
var overlap_1 = __webpack_require__(46282);
var core_1 = __webpack_require__(88009);
var warning_1 = __importDefault(__webpack_require__(42473));
core_1.registerGeometryLabel('base', base_1.default);
core_1.registerGeometryLabel('interval', interval_1.default);
core_1.registerGeometryLabel('pie', pie_1.default);
core_1.registerGeometryLabel('polar', polar_1.default);
core_1.registerGeometryLabelLayout('overlap', overlap_1.overlap);
core_1.registerGeometryLabelLayout('distribute', distribute_1.distribute);
core_1.registerGeometryLabelLayout('fixed-overlap', overlap_1.fixedOverlap);
core_1.registerGeometryLabelLayout('limit-in-shape', limit_in_shape_1.limitInShape);
core_1.registerGeometryLabelLayout('limit-in-canvas', limit_in_canvas_1.limitInCanvas);
function Label(props) {
    var parentInstance = props.parentInstance, content = props.content, cfg = __rest(props, ["parentInstance", "content"]);
    warning_1.default(false, 'Label组件即将被取消，请使用图形组件的label属性进行配置');
    parentInstance.label(false);
    parentInstance.label(content, cfg);
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports["default"] = Label;
//# sourceMappingURL=Label.js.map

/***/ }),

/***/ 19531:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var line_1 = __importDefault(__webpack_require__(1795));
__webpack_require__(95141);
var Base_1 = __importDefault(__webpack_require__(60411));
var core_1 = __webpack_require__(88009);
__webpack_require__(95141);
core_1.registerGeometry('Line', line_1.default);
var LineGeom = /** @class */ (function (_super) {
    __extends(LineGeom, _super);
    function LineGeom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GemoBaseClassName = 'line';
        return _this;
    }
    return LineGeom;
}(Base_1.default));
exports["default"] = LineGeom;
//# sourceMappingURL=Line.js.map

/***/ }),

/***/ 17308:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(67294));
var util_1 = __webpack_require__(3018);
// 按需使用需要加载图形
__webpack_require__(82183);
__webpack_require__(65082);
var is_object_1 = __importDefault(__webpack_require__(33643));
var deep_mix_1 = __importDefault(__webpack_require__(90497));
var get_1 = __importDefault(__webpack_require__(58070));
var set_1 = __importDefault(__webpack_require__(64119));
var core_1 = __webpack_require__(88009);
var d3Color = __importStar(__webpack_require__(46652));
var useChartView_1 = __importDefault(__webpack_require__(45950));
var useChartInstance_1 = __importDefault(__webpack_require__(79235));
var Line_1 = __importDefault(__webpack_require__(19531));
var Point_1 = __importDefault(__webpack_require__(74142));
var Area_1 = __importDefault(__webpack_require__(51522));
var areaStyle = {
    "default": {
        "style": {
            "fill": "#5B8FF9",
            "fillOpacity": 0.25,
            "stroke": null
        }
    },
    "active": {
        "style": { "fillOpacity": 0.5 }
    },
    "inactive": {
        "style": { "fillOpacity": 0.4 }
    },
    "selected": {
        "style": { "fillOpacity": 0.5 }
    }
};
var LineAdvance = function (props) {
    var point = props.point, area = props.area, shape = props.shape, cfg = __rest(props, ["point", "area", "shape"]);
    var pointCfg = { shape: 'circle' };
    var chart = useChartInstance_1.default();
    var view = useChartView_1.default();
    var areaCfg = { shape: shape === 'smooth' ? 'gradient-smooth' : 'gradient' };
    var theme = view.getTheme();
    // todo: 需要g2层修改
    theme.geometries.area.gradient = areaStyle;
    // todo: 需要g2层修改
    theme.geometries.area['gradient-smooth'] = areaStyle;
    if (get_1.default(chart, ['options', 'tooltip']) !== false) {
        // 默认为shared
        if (get_1.default(view, ['options', 'tooltip', 'shared']) === undefined) {
            set_1.default(view, ['options', 'tooltip', 'shared'], true);
        }
        ;
        // 默认showCrosshairs
        if (get_1.default(view, ['options', 'tooltip', 'showCrosshairs']) === undefined) {
            set_1.default(view, ['options', 'tooltip', 'showCrosshairs'], true);
        }
        ;
        if (get_1.default(view, ['options', 'tooltip', 'showMarkers']) === undefined) {
            set_1.default(view, ['options', 'tooltip', 'showMarkers'], true);
        }
        ;
    }
    if (is_object_1.default(pointCfg)) {
        deep_mix_1.default(pointCfg, point);
    }
    if (is_object_1.default(areaCfg)) {
        deep_mix_1.default(areaCfg, area);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Line_1.default, __assign({ shape: shape, state: {
                default: { style: { shadowColor: '#ddd', shadowBlur: 3, shadowOffsetY: 2 } },
                active: { style: { shadowColor: '#ddd', shadowBlur: 3, shadowOffsetY: 5 } },
            } }, cfg)),
        !!area && react_1.default.createElement(Area_1.default, __assign({}, cfg, { tooltip: false }, areaCfg)),
        !!point && react_1.default.createElement(Point_1.default, __assign({ size: 3 }, cfg, { state: {
                active: { style: { stroke: '#fff', lineWidth: 1.5, strokeOpacity: 0.9 } },
            }, tooltip: false }, pointCfg))));
};
// Area 几何标记默认的 shape：填充的区域图
core_1.registerShape('area', 'gradient', {
    draw: function (cfg, container) {
        var attrs = util_1.getShapeAttrs(cfg, false, false, this);
        var c = attrs.fill;
        var clr = d3Color.color(c);
        if (clr) {
            attrs.fill = "l (90) 0:" + d3Color.rgb(clr.r, clr.g, clr.b, 1).formatRgb() + " 1:" + d3Color.rgb(clr.r, clr.g, clr.b, 0.1).formatRgb();
        }
        // attrs.fill = 'red';
        var shape = container.addShape({
            type: 'path',
            attrs: attrs,
            name: 'area',
        });
        return shape;
    },
});
/**
 * 填充的平滑曲面图
 */
core_1.registerShape('area', 'gradient-smooth', {
    draw: function (cfg, container) {
        var coordinate = this.coordinate;
        var attrs = util_1.getShapeAttrs(cfg, false, true, this, util_1.getConstraint(coordinate));
        var c = attrs.fill;
        var clr = d3Color.color(c);
        if (clr) {
            attrs.fill = "l (90) 0:" + d3Color.rgb(clr.r, clr.g, clr.b, 1).formatRgb() + " 1:" + d3Color.rgb(clr.r, clr.g, clr.b, 0.1).formatRgb();
        }
        // attrs.fill = 'red';
        var shape = container.addShape({
            type: 'path',
            attrs: attrs,
            name: 'area',
        });
        return shape;
    }
});
exports["default"] = LineAdvance;
//# sourceMappingURL=LineAdvance.js.map

/***/ }),

/***/ 74142:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var point_1 = __importDefault(__webpack_require__(62935));
var Base_1 = __importDefault(__webpack_require__(60411));
var core_1 = __webpack_require__(88009);
// 注册图形
__webpack_require__(9137);
__webpack_require__(63462);
__webpack_require__(86746);
core_1.registerGeometry('Point', point_1.default);
var PointGeom = /** @class */ (function (_super) {
    __extends(PointGeom, _super);
    function PointGeom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GemoBaseClassName = 'point';
        return _this;
    }
    return PointGeom;
}(Base_1.default));
exports["default"] = PointGeom;
//# sourceMappingURL=Point.js.map

/***/ }),

/***/ 81426:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
// TODO: 按照element 详细分类
var active_1 = __importDefault(__webpack_require__(24030));
var link_by_color_1 = __importDefault(__webpack_require__(32282));
var range_active_1 = __importDefault(__webpack_require__(9246));
var single_active_1 = __importDefault(__webpack_require__(51736));
var highlight_1 = __importDefault(__webpack_require__(57020));
var highlight_by_x_1 = __importDefault(__webpack_require__(64467));
var highlight_by_color_1 = __importDefault(__webpack_require__(90441));
var single_highlight_1 = __importDefault(__webpack_require__(67059));
var range_highlight_1 = __importDefault(__webpack_require__(11150));
var selected_1 = __importDefault(__webpack_require__(71032));
var single_selected_1 = __importDefault(__webpack_require__(41380));
var range_selected_1 = __importDefault(__webpack_require__(89755));
var cursor_1 = __importDefault(__webpack_require__(18445));
var core_1 = __webpack_require__(88009);
core_1.registerAction('cursor', cursor_1.default);
core_1.registerAction('element-active', active_1.default);
core_1.registerAction('element-single-active', single_active_1.default);
core_1.registerAction('element-range-active', range_active_1.default);
core_1.registerAction('element-highlight', highlight_1.default);
core_1.registerAction('element-highlight-by-x', highlight_by_x_1.default);
core_1.registerAction('element-highlight-by-color', highlight_by_color_1.default);
core_1.registerAction('element-single-highlight', single_highlight_1.default);
core_1.registerAction('element-range-highlight', range_highlight_1.default);
core_1.registerAction('element-sibling-highlight', range_highlight_1.default, {
    effectSiblings: true,
    effectByRecord: true
});
core_1.registerAction('element-selected', selected_1.default);
core_1.registerAction('element-single-selected', single_selected_1.default);
core_1.registerAction('element-range-selected', range_selected_1.default);
core_1.registerAction('element-link-by-color', link_by_color_1.default);
// 移动到 elment 上 active
core_1.registerInteraction('element-active', {
    start: [{ trigger: 'element:mouseenter', action: 'element-active:active' }],
    end: [{ trigger: 'element:mouseleave', action: 'element-active:reset' }],
});
// 点击选中，允许取消
core_1.registerInteraction('element-selected', {
    start: [{ trigger: 'element:click', action: 'element-selected:toggle' }],
});
// hover highlight，允许取消
core_1.registerInteraction('element-highlight', {
    start: [{ trigger: 'element:mouseenter', action: 'element-highlight:highlight' }],
    end: [{ trigger: 'element:mouseleave', action: 'element-highlight:reset' }],
});
// hover highlight by x，允许取消
core_1.registerInteraction('element-highlight-by-x', {
    start: [{ trigger: 'element:mouseenter', action: 'element-highlight-by-x:highlight' }],
    end: [{ trigger: 'element:mouseleave', action: 'element-highlight-by-x:reset' }],
});
// hover highlight by y，允许取消
core_1.registerInteraction('element-highlight-by-color', {
    start: [{ trigger: 'element:mouseenter', action: 'element-highlight-by-color:highlight' }],
    end: [{ trigger: 'element:mouseleave', action: 'element-highlight-by-color:reset' }],
});
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ 79235:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useChartTheme = void 0;
var react_1 = __importDefault(__webpack_require__(67294));
var root_1 = __importDefault(__webpack_require__(62059));
function useChartInstance() {
    return react_1.default.useContext(root_1.default).chart;
}
exports["default"] = useChartInstance;
function useChartTheme() {
    // todo: 局部配置的theme 合并 chart自己的theme
    return react_1.default.useContext(root_1.default).theme;
}
exports.useChartTheme = useChartTheme;
//# sourceMappingURL=useChartInstance.js.map

/***/ }),

/***/ 45950:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __importDefault(__webpack_require__(67294));
var view_1 = __importDefault(__webpack_require__(14244));
function useView() {
    // @ts-ignore
    return react_1.default.useContext(view_1.default);
}
exports["default"] = useView;
//# sourceMappingURL=useChartView.js.map

/***/ }),

/***/ 95413:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.antvDark = exports.antvLight = exports.createThemeByStyleSheet = void 0;
// 注册主题
var dark_1 = __webpack_require__(48109);
Object.defineProperty(exports, "antvDark", ({ enumerable: true, get: function () { return dark_1.antvDark; } }));
var light_1 = __webpack_require__(40999);
Object.defineProperty(exports, "antvLight", ({ enumerable: true, get: function () { return light_1.antvLight; } }));
var create_by_style_sheet_1 = __webpack_require__(31630);
Object.defineProperty(exports, "createThemeByStyleSheet", ({ enumerable: true, get: function () { return create_by_style_sheet_1.createThemeByStyleSheet; } }));
var theme_1 = __webpack_require__(90072);
theme_1.registerTheme('dark', create_by_style_sheet_1.createThemeByStyleSheet(dark_1.antvDark));
theme_1.registerTheme('default', create_by_style_sheet_1.createThemeByStyleSheet(light_1.antvLight));
theme_1.registerTheme('light', create_by_style_sheet_1.createThemeByStyleSheet(light_1.antvLight));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 56956:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var is_array_1 = __importDefault(__webpack_require__(66631));
var for_in_1 = __importDefault(__webpack_require__(8361));
var cloneDeep = function (deepObject) {
    var map = [];
    var clone = function (obj) {
        map.push(obj);
        if (map.includes(obj)) {
            return obj;
        }
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }
        var rst;
        if (is_array_1.default(obj)) {
            rst = [];
            for (var i = 0, l = obj.length; i < l; i++) {
                if (typeof obj[i] === 'object' && obj[i] != null) {
                    rst[i] = clone(obj[i]);
                }
                else {
                    rst[i] = obj[i];
                }
            }
        }
        else {
            rst = {};
            for_in_1.default(obj, function (value, k) {
                if (typeof value === 'object' && value != null) {
                    rst[k] = clone(value);
                }
                else {
                    rst[k] = value;
                }
            });
        }
        return rst;
    };
    return clone(deepObject);
};
exports["default"] = cloneDeep;
//# sourceMappingURL=cloneDeep.js.map

/***/ }),

/***/ 75665:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
/**
 * 对比不一致则执行回调
*/
var each_1 = __importDefault(__webpack_require__(27154));
var is_array_1 = __importDefault(__webpack_require__(66631));
var shallowEqual_1 = __importDefault(__webpack_require__(41041));
exports["default"] = (function (preProps, nextProps, keys, callback) {
    // preProps 为null 即初始化。
    if (preProps === null) {
        each_1.default(keys, function (key) {
            var value = nextProps[key];
            if (value !== undefined) {
                if (!is_array_1.default(value)) {
                    value = [value];
                }
                callback(value, key);
            }
        });
        return;
    }
    var value;
    var nextValue;
    each_1.default(keys, function (key) {
        value = preProps[key];
        nextValue = nextProps[key];
        if (!shallowEqual_1.default(nextValue, value)) {
            if (!is_array_1.default(nextValue)) {
                nextValue = [nextValue];
            }
            callback(nextValue, key);
        }
    });
});
//# sourceMappingURL=compareProps.js.map

/***/ }),

/***/ 50891:
/***/ (function(__unused_webpack_module, exports) {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.REACT_PIVATE_PROPS = void 0;
exports.REACT_PIVATE_PROPS = ['children', 'hooks', 'ref'];
exports["default"] = {};
//# sourceMappingURL=constant.js.map

/***/ }),

/***/ 88647:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var each_1 = __importDefault(__webpack_require__(27154));
var is_string_1 = __importDefault(__webpack_require__(21830));
// 支持正则匹配
var pickWithout = function (obj, keys) {
    var ret = {};
    each_1.default(obj, function (v, k) {
        var match = false;
        keys.forEach(function (itKey) {
            if (is_string_1.default(itKey) && itKey === k) {
                match = true;
            }
            else if (itKey instanceof RegExp && k.match(itKey)) {
                match = true;
            }
        });
        if (!match) {
            ret[k] = v;
        }
    });
    return ret;
};
exports["default"] = pickWithout;
//# sourceMappingURL=pickWithout.js.map

/***/ }),

/***/ 41041:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var each_1 = __importDefault(__webpack_require__(27154));
var is_array_1 = __importDefault(__webpack_require__(66631));
var is_object_1 = __importDefault(__webpack_require__(33643));
function is(x, y) {
    if (x === y) {
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    return x !== x && y !== y; //  NaN == NaN
}
function length(obj) {
    if (is_array_1.default(obj)) {
        return obj.length;
    }
    if (is_object_1.default(obj)) {
        return Object.keys(obj).length;
    }
    return 0;
}
function default_1(objA, objB) {
    if (is(objA, objB)) {
        return true;
    }
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
        return false;
    }
    if (is_array_1.default(objA) !== is_array_1.default(objB)) {
        return false;
    }
    if (length(objA) !== length(objB)) {
        return false;
    }
    var ret = true;
    each_1.default(objA, function (v, k) {
        if (!is(v, objB[k])) {
            ret = false;
            return ret;
        }
        return true;
    });
    return ret;
}
exports["default"] = default_1;
//# sourceMappingURL=shallowEqual.js.map

/***/ }),

/***/ 54512:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var clone_1 = __importDefault(__webpack_require__(8289));
// g2 的配置项为 xxCfg | null
exports["default"] = (function (cfg, keys) {
    var opt = clone_1.default(cfg);
    keys.forEach(function (key) {
        if (opt[key] === true) {
            opt[key] = {};
        }
        else if (opt[key] === false) {
            opt[key] = null;
        }
    });
    return opt;
});
//# sourceMappingURL=transBooleanCfg.js.map

/***/ }),

/***/ 46652:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "color": function() { return /* reexport */ color/* default */.ZP; },
  "cubehelix": function() { return /* reexport */ cubehelix; },
  "gray": function() { return /* reexport */ gray; },
  "hcl": function() { return /* reexport */ hcl; },
  "hsl": function() { return /* reexport */ color/* hsl */.Ym; },
  "lab": function() { return /* reexport */ lab; },
  "lch": function() { return /* reexport */ lch; },
  "rgb": function() { return /* reexport */ color/* rgb */.B8; }
});

// EXTERNAL MODULE: ./node_modules/d3-color/src/color.js
var color = __webpack_require__(16372);
// EXTERNAL MODULE: ./node_modules/d3-color/src/define.js
var src_define = __webpack_require__(44087);
;// CONCATENATED MODULE: ./node_modules/d3-color/src/math.js
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;

;// CONCATENATED MODULE: ./node_modules/d3-color/src/lab.js




// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof color/* Rgb */.Ss)) o = (0,color/* rgbConvert */.SU)(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

(0,src_define/* default */.Z)(Lab, lab, (0,src_define/* extend */.l)(color/* Color */.Il, {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new color/* Rgb */.Ss(
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * rad2deg;
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * deg2rad;
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

(0,src_define/* default */.Z)(Hcl, hcl, (0,src_define/* extend */.l)(color/* Color */.Il, {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));

;// CONCATENATED MODULE: ./node_modules/d3-color/src/cubehelix.js




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof color/* Rgb */.Ss)) o = (0,color/* rgbConvert */.SU)(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

(0,src_define/* default */.Z)(Cubehelix, cubehelix, (0,src_define/* extend */.l)(color/* Color */.Il, {
  brighter: function(k) {
    k = k == null ? color/* brighter */.J5 : Math.pow(color/* brighter */.J5, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? color/* darker */.xV : Math.pow(color/* darker */.xV, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new color/* Rgb */.Ss(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

;// CONCATENATED MODULE: ./node_modules/d3-color/src/index.js





/***/ }),

/***/ 44626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "easeBack": function() { return /* reexport */ backInOut; },
  "easeBackIn": function() { return /* reexport */ backIn; },
  "easeBackInOut": function() { return /* reexport */ backInOut; },
  "easeBackOut": function() { return /* reexport */ backOut; },
  "easeBounce": function() { return /* reexport */ bounceOut; },
  "easeBounceIn": function() { return /* reexport */ bounceIn; },
  "easeBounceInOut": function() { return /* reexport */ bounceInOut; },
  "easeBounceOut": function() { return /* reexport */ bounceOut; },
  "easeCircle": function() { return /* reexport */ circleInOut; },
  "easeCircleIn": function() { return /* reexport */ circleIn; },
  "easeCircleInOut": function() { return /* reexport */ circleInOut; },
  "easeCircleOut": function() { return /* reexport */ circleOut; },
  "easeCubic": function() { return /* reexport */ cubicInOut; },
  "easeCubicIn": function() { return /* reexport */ cubicIn; },
  "easeCubicInOut": function() { return /* reexport */ cubicInOut; },
  "easeCubicOut": function() { return /* reexport */ cubicOut; },
  "easeElastic": function() { return /* reexport */ elasticOut; },
  "easeElasticIn": function() { return /* reexport */ elasticIn; },
  "easeElasticInOut": function() { return /* reexport */ elasticInOut; },
  "easeElasticOut": function() { return /* reexport */ elasticOut; },
  "easeExp": function() { return /* reexport */ expInOut; },
  "easeExpIn": function() { return /* reexport */ expIn; },
  "easeExpInOut": function() { return /* reexport */ expInOut; },
  "easeExpOut": function() { return /* reexport */ expOut; },
  "easeLinear": function() { return /* reexport */ linear; },
  "easePoly": function() { return /* reexport */ polyInOut; },
  "easePolyIn": function() { return /* reexport */ polyIn; },
  "easePolyInOut": function() { return /* reexport */ polyInOut; },
  "easePolyOut": function() { return /* reexport */ polyOut; },
  "easeQuad": function() { return /* reexport */ quadInOut; },
  "easeQuadIn": function() { return /* reexport */ quadIn; },
  "easeQuadInOut": function() { return /* reexport */ quadInOut; },
  "easeQuadOut": function() { return /* reexport */ quadOut; },
  "easeSin": function() { return /* reexport */ sinInOut; },
  "easeSinIn": function() { return /* reexport */ sinIn; },
  "easeSinInOut": function() { return /* reexport */ sinInOut; },
  "easeSinOut": function() { return /* reexport */ sinOut; }
});

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/linear.js
function linear(t) {
  return +t;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/quad.js
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/cubic.js
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/poly.js
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/sin.js
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return (+t === 1) ? 1 : 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/math.js
// tpmt is two power minus ten times t scaled to [0,1]
function tpmt(x) {
  return (Math.pow(2, -10 * x) - 0.0009765625) * 1.0009775171065494;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/exp.js


function expIn(t) {
  return tpmt(1 - +t);
}

function expOut(t) {
  return 1 - tpmt(t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? tpmt(1 - t) : 2 - tpmt(t - 1)) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/circle.js
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/bounce.js
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/back.js
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return (t = +t) * t * (s * (t - 1) + t);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((t + 1) * s + t) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/elastic.js


var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * tpmt(-(--t)) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * tpmt(t = +t) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * tpmt(-t) * Math.sin((s - t) / p)
        : 2 - a * tpmt(t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);

;// CONCATENATED MODULE: ./node_modules/d3-ease/src/index.js





















/***/ }),

/***/ 35374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HT": function() { return /* binding */ timer; }
/* harmony export */ });
/* unused harmony exports now, Timer, timerFlush */
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),

/***/ 43631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BotInfo": function() { return /* binding */ BotInfo; },
/* harmony export */   "BrowserInfo": function() { return /* binding */ BrowserInfo; },
/* harmony export */   "NodeInfo": function() { return /* binding */ NodeInfo; },
/* harmony export */   "ReactNativeInfo": function() { return /* binding */ ReactNativeInfo; },
/* harmony export */   "SearchBotDeviceInfo": function() { return /* binding */ SearchBotDeviceInfo; },
/* harmony export */   "browserName": function() { return /* binding */ browserName; },
/* harmony export */   "detect": function() { return /* binding */ detect; },
/* harmony export */   "detectOS": function() { return /* binding */ detectOS; },
/* harmony export */   "getNodeVersion": function() { return /* binding */ getNodeVersion; },
/* harmony export */   "parseUserAgent": function() { return /* binding */ parseUserAgent; }
/* harmony export */ });
/* provided dependency */ var process = __webpack_require__(83454);
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.type = 'browser';
    }
    return BrowserInfo;
}());

var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.type = 'node';
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());

var SearchBotDeviceInfo = /** @class */ (function () {
    function SearchBotDeviceInfo(name, version, os, bot) {
        this.name = name;
        this.version = version;
        this.os = os;
        this.bot = bot;
        this.type = 'bot-device';
    }
    return SearchBotDeviceInfo;
}());

var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.type = 'bot';
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());

var ReactNativeInfo = /** @class */ (function () {
    function ReactNativeInfo() {
        this.type = 'react-native';
        this.name = 'react-native';
        this.version = null;
        this.os = null;
    }
    return ReactNativeInfo;
}());

// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk|curl|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask\ Jeeves\/Teoma|ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /EdgA?\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['pie', /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/],
    ['pie', /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/],
    ['netfront', /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FB[AS]V\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['curl', /^curl\/([0-9\.]+)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Windows CE', /Windows CE|WinCE|Microsoft Pocket Internet Explorer/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof document === 'undefined' &&
        typeof navigator !== 'undefined' &&
        navigator.product === 'ReactNative') {
        return new ReactNativeInfo();
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
function matchUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    return (ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false));
}
function browserName(ua) {
    var data = matchUserAgent(ua);
    return data ? data[0] : null;
}
function parseUserAgent(ua) {
    var matchedRule = matchUserAgent(ua);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    // Do not use RegExp for split operation as some browser do not support it (See: http://blog.stevenlevithan.com/archives/cross-browser-split)
    var versionParts = match[1] && match[1].split('.').join('_').split('_').slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArray(__spreadArray([], versionParts, true), createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length), true);
        }
    }
    else {
        versionParts = [];
    }
    var version = versionParts.join('.');
    var os = detectOS(ua);
    var searchBotMatch = SEARCHBOT_OS_REGEX.exec(ua);
    if (searchBotMatch && searchBotMatch[1]) {
        return new SearchBotDeviceInfo(name, version, os, searchBotMatch[1]);
    }
    return new BrowserInfo(name, version, os);
}
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.exec(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}


/***/ }),

/***/ 19432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "assign": function() { return /* binding */ assign; },
/* harmony export */   "defaultI18n": function() { return /* binding */ defaultI18n; },
/* harmony export */   "format": function() { return /* binding */ format; },
/* harmony export */   "parse": function() { return /* binding */ parse; },
/* harmony export */   "setGlobalDateI18n": function() { return /* binding */ setGlobalDateI18n; },
/* harmony export */   "setGlobalDateMasks": function() { return /* binding */ setGlobalDateMasks; }
/* harmony export */ });
var token = /d{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|Z|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g;
var twoDigitsOptional = "\\d\\d?";
var twoDigits = "\\d\\d";
var threeDigits = "\\d{3}";
var fourDigits = "\\d{4}";
var word = "[^\\s]+";
var literal = /\[([^]*?)\]/gm;
function shorten(arr, sLen) {
    var newArr = [];
    for (var i = 0, len = arr.length; i < len; i++) {
        newArr.push(arr[i].substr(0, sLen));
    }
    return newArr;
}
var monthUpdate = function (arrName) { return function (v, i18n) {
    var lowerCaseArr = i18n[arrName].map(function (v) { return v.toLowerCase(); });
    var index = lowerCaseArr.indexOf(v.toLowerCase());
    if (index > -1) {
        return index;
    }
    return null;
}; };
function assign(origObj) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var obj = args_1[_a];
        for (var key in obj) {
            // @ts-ignore ex
            origObj[key] = obj[key];
        }
    }
    return origObj;
}
var dayNames = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var monthNamesShort = shorten(monthNames, 3);
var dayNamesShort = shorten(dayNames, 3);
var defaultI18n = {
    dayNamesShort: dayNamesShort,
    dayNames: dayNames,
    monthNamesShort: monthNamesShort,
    monthNames: monthNames,
    amPm: ["am", "pm"],
    DoFn: function (dayOfMonth) {
        return (dayOfMonth +
            ["th", "st", "nd", "rd"][dayOfMonth % 10 > 3
                ? 0
                : ((dayOfMonth - (dayOfMonth % 10) !== 10 ? 1 : 0) * dayOfMonth) % 10]);
    }
};
var globalI18n = assign({}, defaultI18n);
var setGlobalDateI18n = function (i18n) {
    return (globalI18n = assign(globalI18n, i18n));
};
var regexEscape = function (str) {
    return str.replace(/[|\\{()[^$+*?.-]/g, "\\$&");
};
var pad = function (val, len) {
    if (len === void 0) { len = 2; }
    val = String(val);
    while (val.length < len) {
        val = "0" + val;
    }
    return val;
};
var formatFlags = {
    D: function (dateObj) { return String(dateObj.getDate()); },
    DD: function (dateObj) { return pad(dateObj.getDate()); },
    Do: function (dateObj, i18n) {
        return i18n.DoFn(dateObj.getDate());
    },
    d: function (dateObj) { return String(dateObj.getDay()); },
    dd: function (dateObj) { return pad(dateObj.getDay()); },
    ddd: function (dateObj, i18n) {
        return i18n.dayNamesShort[dateObj.getDay()];
    },
    dddd: function (dateObj, i18n) {
        return i18n.dayNames[dateObj.getDay()];
    },
    M: function (dateObj) { return String(dateObj.getMonth() + 1); },
    MM: function (dateObj) { return pad(dateObj.getMonth() + 1); },
    MMM: function (dateObj, i18n) {
        return i18n.monthNamesShort[dateObj.getMonth()];
    },
    MMMM: function (dateObj, i18n) {
        return i18n.monthNames[dateObj.getMonth()];
    },
    YY: function (dateObj) {
        return pad(String(dateObj.getFullYear()), 4).substr(2);
    },
    YYYY: function (dateObj) { return pad(dateObj.getFullYear(), 4); },
    h: function (dateObj) { return String(dateObj.getHours() % 12 || 12); },
    hh: function (dateObj) { return pad(dateObj.getHours() % 12 || 12); },
    H: function (dateObj) { return String(dateObj.getHours()); },
    HH: function (dateObj) { return pad(dateObj.getHours()); },
    m: function (dateObj) { return String(dateObj.getMinutes()); },
    mm: function (dateObj) { return pad(dateObj.getMinutes()); },
    s: function (dateObj) { return String(dateObj.getSeconds()); },
    ss: function (dateObj) { return pad(dateObj.getSeconds()); },
    S: function (dateObj) {
        return String(Math.round(dateObj.getMilliseconds() / 100));
    },
    SS: function (dateObj) {
        return pad(Math.round(dateObj.getMilliseconds() / 10), 2);
    },
    SSS: function (dateObj) { return pad(dateObj.getMilliseconds(), 3); },
    a: function (dateObj, i18n) {
        return dateObj.getHours() < 12 ? i18n.amPm[0] : i18n.amPm[1];
    },
    A: function (dateObj, i18n) {
        return dateObj.getHours() < 12
            ? i18n.amPm[0].toUpperCase()
            : i18n.amPm[1].toUpperCase();
    },
    ZZ: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60) * 100 + (Math.abs(offset) % 60), 4));
    },
    Z: function (dateObj) {
        var offset = dateObj.getTimezoneOffset();
        return ((offset > 0 ? "-" : "+") +
            pad(Math.floor(Math.abs(offset) / 60), 2) +
            ":" +
            pad(Math.abs(offset) % 60, 2));
    }
};
var monthParse = function (v) { return +v - 1; };
var emptyDigits = [null, twoDigitsOptional];
var emptyWord = [null, word];
var amPm = [
    "isPm",
    word,
    function (v, i18n) {
        var val = v.toLowerCase();
        if (val === i18n.amPm[0]) {
            return 0;
        }
        else if (val === i18n.amPm[1]) {
            return 1;
        }
        return null;
    }
];
var timezoneOffset = [
    "timezoneOffset",
    "[^\\s]*?[\\+\\-]\\d\\d:?\\d\\d|[^\\s]*?Z?",
    function (v) {
        var parts = (v + "").match(/([+-]|\d\d)/gi);
        if (parts) {
            var minutes = +parts[1] * 60 + parseInt(parts[2], 10);
            return parts[0] === "+" ? minutes : -minutes;
        }
        return 0;
    }
];
var parseFlags = {
    D: ["day", twoDigitsOptional],
    DD: ["day", twoDigits],
    Do: ["day", twoDigitsOptional + word, function (v) { return parseInt(v, 10); }],
    M: ["month", twoDigitsOptional, monthParse],
    MM: ["month", twoDigits, monthParse],
    YY: [
        "year",
        twoDigits,
        function (v) {
            var now = new Date();
            var cent = +("" + now.getFullYear()).substr(0, 2);
            return +("" + (+v > 68 ? cent - 1 : cent) + v);
        }
    ],
    h: ["hour", twoDigitsOptional, undefined, "isPm"],
    hh: ["hour", twoDigits, undefined, "isPm"],
    H: ["hour", twoDigitsOptional],
    HH: ["hour", twoDigits],
    m: ["minute", twoDigitsOptional],
    mm: ["minute", twoDigits],
    s: ["second", twoDigitsOptional],
    ss: ["second", twoDigits],
    YYYY: ["year", fourDigits],
    S: ["millisecond", "\\d", function (v) { return +v * 100; }],
    SS: ["millisecond", twoDigits, function (v) { return +v * 10; }],
    SSS: ["millisecond", threeDigits],
    d: emptyDigits,
    dd: emptyDigits,
    ddd: emptyWord,
    dddd: emptyWord,
    MMM: ["month", word, monthUpdate("monthNamesShort")],
    MMMM: ["month", word, monthUpdate("monthNames")],
    a: amPm,
    A: amPm,
    ZZ: timezoneOffset,
    Z: timezoneOffset
};
// Some common format strings
var globalMasks = {
    default: "ddd MMM DD YYYY HH:mm:ss",
    shortDate: "M/D/YY",
    mediumDate: "MMM D, YYYY",
    longDate: "MMMM D, YYYY",
    fullDate: "dddd, MMMM D, YYYY",
    isoDate: "YYYY-MM-DD",
    isoDateTime: "YYYY-MM-DDTHH:mm:ssZ",
    shortTime: "HH:mm",
    mediumTime: "HH:mm:ss",
    longTime: "HH:mm:ss.SSS"
};
var setGlobalDateMasks = function (masks) { return assign(globalMasks, masks); };
/***
 * Format a date
 * @method format
 * @param {Date|number} dateObj
 * @param {string} mask Format of the date, i.e. 'mm-dd-yy' or 'shortDate'
 * @returns {string} Formatted date string
 */
var format = function (dateObj, mask, i18n) {
    if (mask === void 0) { mask = globalMasks["default"]; }
    if (i18n === void 0) { i18n = {}; }
    if (typeof dateObj === "number") {
        dateObj = new Date(dateObj);
    }
    if (Object.prototype.toString.call(dateObj) !== "[object Date]" ||
        isNaN(dateObj.getTime())) {
        throw new Error("Invalid Date pass to format");
    }
    mask = globalMasks[mask] || mask;
    var literals = [];
    // Make literals inactive by replacing them with @@@
    mask = mask.replace(literal, function ($0, $1) {
        literals.push($1);
        return "@@@";
    });
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // Apply formatting rules
    mask = mask.replace(token, function ($0) {
        return formatFlags[$0](dateObj, combinedI18nSettings);
    });
    // Inline literal values back into the formatted value
    return mask.replace(/@@@/g, function () { return literals.shift(); });
};
/**
 * Parse a date string into a Javascript Date object /
 * @method parse
 * @param {string} dateStr Date string
 * @param {string} format Date parse format
 * @param {i18n} I18nSettingsOptional Full or subset of I18N settings
 * @returns {Date|null} Returns Date object. Returns null what date string is invalid or doesn't match format
 */
function parse(dateStr, format, i18n) {
    if (i18n === void 0) { i18n = {}; }
    if (typeof format !== "string") {
        throw new Error("Invalid format in fecha parse");
    }
    // Check to see if the format is actually a mask
    format = globalMasks[format] || format;
    // Avoid regular expression denial of service, fail early for really long strings
    // https://www.owasp.org/index.php/Regular_expression_Denial_of_Service_-_ReDoS
    if (dateStr.length > 1000) {
        return null;
    }
    // Default to the beginning of the year.
    var today = new Date();
    var dateInfo = {
        year: today.getFullYear(),
        month: 0,
        day: 1,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        isPm: null,
        timezoneOffset: null
    };
    var parseInfo = [];
    var literals = [];
    // Replace all the literals with @@@. Hopefully a string that won't exist in the format
    var newFormat = format.replace(literal, function ($0, $1) {
        literals.push(regexEscape($1));
        return "@@@";
    });
    var specifiedFields = {};
    var requiredFields = {};
    // Change every token that we find into the correct regex
    newFormat = regexEscape(newFormat).replace(token, function ($0) {
        var info = parseFlags[$0];
        var field = info[0], regex = info[1], requiredField = info[3];
        // Check if the person has specified the same field twice. This will lead to confusing results.
        if (specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " specified twice in format");
        }
        specifiedFields[field] = true;
        // Check if there are any required fields. For instance, 12 hour time requires AM/PM specified
        if (requiredField) {
            requiredFields[requiredField] = true;
        }
        parseInfo.push(info);
        return "(" + regex + ")";
    });
    // Check all the required fields are present
    Object.keys(requiredFields).forEach(function (field) {
        if (!specifiedFields[field]) {
            throw new Error("Invalid format. " + field + " is required in specified format");
        }
    });
    // Add back all the literals after
    newFormat = newFormat.replace(/@@@/g, function () { return literals.shift(); });
    // Check if the date string matches the format. If it doesn't return null
    var matches = dateStr.match(new RegExp(newFormat, "i"));
    if (!matches) {
        return null;
    }
    var combinedI18nSettings = assign(assign({}, globalI18n), i18n);
    // For each match, call the parser function for that date part
    for (var i = 1; i < matches.length; i++) {
        var _a = parseInfo[i - 1], field = _a[0], parser = _a[2];
        var value = parser
            ? parser(matches[i], combinedI18nSettings)
            : +matches[i];
        // If the parser can't make sense of the value, return null
        if (value == null) {
            return null;
        }
        dateInfo[field] = value;
    }
    if (dateInfo.isPm === 1 && dateInfo.hour != null && +dateInfo.hour !== 12) {
        dateInfo.hour = +dateInfo.hour + 12;
    }
    else if (dateInfo.isPm === 0 && +dateInfo.hour === 12) {
        dateInfo.hour = 0;
    }
    var dateTZ;
    if (dateInfo.timezoneOffset == null) {
        dateTZ = new Date(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute, dateInfo.second, dateInfo.millisecond);
        var validateFields = [
            ["month", "getMonth"],
            ["day", "getDate"],
            ["hour", "getHours"],
            ["minute", "getMinutes"],
            ["second", "getSeconds"]
        ];
        for (var i = 0, len = validateFields.length; i < len; i++) {
            // Check to make sure the date field is within the allowed range. Javascript dates allows values
            // outside the allowed range. If the values don't match the value was invalid
            if (specifiedFields[validateFields[i][0]] &&
                dateInfo[validateFields[i][0]] !== dateTZ[validateFields[i][1]]()) {
                return null;
            }
        }
    }
    else {
        dateTZ = new Date(Date.UTC(dateInfo.year, dateInfo.month, dateInfo.day, dateInfo.hour, dateInfo.minute - dateInfo.timezoneOffset, dateInfo.second, dateInfo.millisecond));
        // We can't validate dates in another timezone unfortunately. Do a basic check instead
        if (dateInfo.month > 11 ||
            dateInfo.month < 0 ||
            dateInfo.day > 31 ||
            dateInfo.day < 1 ||
            dateInfo.hour > 23 ||
            dateInfo.hour < 0 ||
            dateInfo.minute > 59 ||
            dateInfo.minute < 0 ||
            dateInfo.second > 59 ||
            dateInfo.second < 0) {
            return null;
        }
    }
    // Don't allow invalid dates
    return dateTZ;
}
var fecha = {
    format: format,
    parse: parse,
    defaultI18n: defaultI18n,
    setGlobalDateI18n: setGlobalDateI18n,
    setGlobalDateMasks: setGlobalDateMasks
};

/* harmony default export */ __webpack_exports__["default"] = (fecha);

//# sourceMappingURL=fecha.js.map


/***/ }),

/***/ 49685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ RANDOM; },
/* harmony export */   "Ib": function() { return /* binding */ EPSILON; },
/* harmony export */   "WT": function() { return /* binding */ ARRAY_TYPE; }
/* harmony export */ });
/* unused harmony exports setMatrixArrayType, toRadian, equals */
/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var RANDOM = Math.random;
/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Float32ArrayConstructor | ArrayConstructor} type Array type, such as Float32Array or Array
 */

function setMatrixArrayType(type) {
  ARRAY_TYPE = type;
}
var degree = Math.PI / 180;
/**
 * Convert Degree To Radian
 *
 * @param {Number} a Angle in Degrees
 */

function toRadian(a) {
  return a * degree;
}
/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 *
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */

function equals(a, b) {
  return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
      i = arguments.length;

  while (i--) {
    y += arguments[i] * arguments[i];
  }

  return Math.sqrt(y);
};

/***/ }),

/***/ 35600:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": function() { return /* binding */ add; },
/* harmony export */   "adjoint": function() { return /* binding */ adjoint; },
/* harmony export */   "clone": function() { return /* binding */ clone; },
/* harmony export */   "copy": function() { return /* binding */ copy; },
/* harmony export */   "create": function() { return /* binding */ create; },
/* harmony export */   "determinant": function() { return /* binding */ determinant; },
/* harmony export */   "equals": function() { return /* binding */ equals; },
/* harmony export */   "exactEquals": function() { return /* binding */ exactEquals; },
/* harmony export */   "frob": function() { return /* binding */ frob; },
/* harmony export */   "fromMat2d": function() { return /* binding */ fromMat2d; },
/* harmony export */   "fromMat4": function() { return /* binding */ fromMat4; },
/* harmony export */   "fromQuat": function() { return /* binding */ fromQuat; },
/* harmony export */   "fromRotation": function() { return /* binding */ fromRotation; },
/* harmony export */   "fromScaling": function() { return /* binding */ fromScaling; },
/* harmony export */   "fromTranslation": function() { return /* binding */ fromTranslation; },
/* harmony export */   "fromValues": function() { return /* binding */ fromValues; },
/* harmony export */   "identity": function() { return /* binding */ identity; },
/* harmony export */   "invert": function() { return /* binding */ invert; },
/* harmony export */   "mul": function() { return /* binding */ mul; },
/* harmony export */   "multiply": function() { return /* binding */ multiply; },
/* harmony export */   "multiplyScalar": function() { return /* binding */ multiplyScalar; },
/* harmony export */   "multiplyScalarAndAdd": function() { return /* binding */ multiplyScalarAndAdd; },
/* harmony export */   "normalFromMat4": function() { return /* binding */ normalFromMat4; },
/* harmony export */   "projection": function() { return /* binding */ projection; },
/* harmony export */   "rotate": function() { return /* binding */ rotate; },
/* harmony export */   "scale": function() { return /* binding */ scale; },
/* harmony export */   "set": function() { return /* binding */ set; },
/* harmony export */   "str": function() { return /* binding */ str; },
/* harmony export */   "sub": function() { return /* binding */ sub; },
/* harmony export */   "subtract": function() { return /* binding */ subtract; },
/* harmony export */   "translate": function() { return /* binding */ translate; },
/* harmony export */   "transpose": function() { return /* binding */ transpose; }
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49685);

/**
 * 3x3 Matrix
 * @module mat3
 */

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(9);

  if (_common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
  }

  out[0] = 1;
  out[4] = 1;
  out[8] = 1;
  return out;
}
/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {ReadonlyMat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */

function fromMat4(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[4];
  out[4] = a[5];
  out[5] = a[6];
  out[6] = a[8];
  out[7] = a[9];
  out[8] = a[10];
  return out;
}
/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(9);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */

function fromValues(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(9);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */

function set(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m10;
  out[4] = m11;
  out[5] = m12;
  out[6] = m20;
  out[7] = m21;
  out[8] = m22;
  return out;
}
/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
        a02 = a[2],
        a12 = a[5];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a01;
    out[5] = a[7];
    out[6] = a02;
    out[7] = a12;
  } else {
    out[0] = a[0];
    out[1] = a[3];
    out[2] = a[6];
    out[3] = a[1];
    out[4] = a[4];
    out[5] = a[7];
    out[6] = a[2];
    out[7] = a[5];
    out[8] = a[8];
  }

  return out;
}
/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function invert(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b01 = a22 * a11 - a12 * a21;
  var b11 = -a22 * a10 + a12 * a20;
  var b21 = a21 * a10 - a11 * a20; // Calculate the determinant

  var det = a00 * b01 + a01 * b11 + a02 * b21;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = b01 * det;
  out[1] = (-a22 * a01 + a02 * a21) * det;
  out[2] = (a12 * a01 - a02 * a11) * det;
  out[3] = b11 * det;
  out[4] = (a22 * a00 - a02 * a20) * det;
  out[5] = (-a12 * a00 + a02 * a10) * det;
  out[6] = b21 * det;
  out[7] = (-a21 * a00 + a01 * a20) * det;
  out[8] = (a11 * a00 - a01 * a10) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the source matrix
 * @returns {mat3} out
 */

function adjoint(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  out[0] = a11 * a22 - a12 * a21;
  out[1] = a02 * a21 - a01 * a22;
  out[2] = a01 * a12 - a02 * a11;
  out[3] = a12 * a20 - a10 * a22;
  out[4] = a00 * a22 - a02 * a20;
  out[5] = a02 * a10 - a00 * a12;
  out[6] = a10 * a21 - a11 * a20;
  out[7] = a01 * a20 - a00 * a21;
  out[8] = a00 * a11 - a01 * a10;
  return out;
}
/**
 * Calculates the determinant of a mat3
 *
 * @param {ReadonlyMat3} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant(a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function multiply(out, a, b) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2];
  var a10 = a[3],
      a11 = a[4],
      a12 = a[5];
  var a20 = a[6],
      a21 = a[7],
      a22 = a[8];
  var b00 = b[0],
      b01 = b[1],
      b02 = b[2];
  var b10 = b[3],
      b11 = b[4],
      b12 = b[5];
  var b20 = b[6],
      b21 = b[7],
      b22 = b[8];
  out[0] = b00 * a00 + b01 * a10 + b02 * a20;
  out[1] = b00 * a01 + b01 * a11 + b02 * a21;
  out[2] = b00 * a02 + b01 * a12 + b02 * a22;
  out[3] = b10 * a00 + b11 * a10 + b12 * a20;
  out[4] = b10 * a01 + b11 * a11 + b12 * a21;
  out[5] = b10 * a02 + b11 * a12 + b12 * a22;
  out[6] = b20 * a00 + b21 * a10 + b22 * a20;
  out[7] = b20 * a01 + b21 * a11 + b22 * a21;
  out[8] = b20 * a02 + b21 * a12 + b22 * a22;
  return out;
}
/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to translate
 * @param {ReadonlyVec2} v vector to translate by
 * @returns {mat3} out
 */

function translate(out, a, v) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      x = v[0],
      y = v[1];
  out[0] = a00;
  out[1] = a01;
  out[2] = a02;
  out[3] = a10;
  out[4] = a11;
  out[5] = a12;
  out[6] = x * a00 + y * a10 + a20;
  out[7] = x * a01 + y * a11 + a21;
  out[8] = x * a02 + y * a12 + a22;
  return out;
}
/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function rotate(out, a, rad) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a10 = a[3],
      a11 = a[4],
      a12 = a[5],
      a20 = a[6],
      a21 = a[7],
      a22 = a[8],
      s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c * a00 + s * a10;
  out[1] = c * a01 + s * a11;
  out[2] = c * a02 + s * a12;
  out[3] = c * a10 - s * a00;
  out[4] = c * a11 - s * a01;
  out[5] = c * a12 - s * a02;
  out[6] = a20;
  out[7] = a21;
  out[8] = a22;
  return out;
}
/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to rotate
 * @param {ReadonlyVec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/

function scale(out, a, v) {
  var x = v[0],
      y = v[1];
  out[0] = x * a[0];
  out[1] = x * a[1];
  out[2] = x * a[2];
  out[3] = y * a[3];
  out[4] = y * a[4];
  out[5] = y * a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Translation vector
 * @returns {mat3} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 1;
  out[5] = 0;
  out[6] = v[0];
  out[7] = v[1];
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */

function fromRotation(out, rad) {
  var s = Math.sin(rad),
      c = Math.cos(rad);
  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = -s;
  out[4] = c;
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyVec2} v Scaling vector
 * @returns {mat3} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = v[1];
  out[5] = 0;
  out[6] = 0;
  out[7] = 0;
  out[8] = 1;
  return out;
}
/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat2d} a the matrix to copy
 * @returns {mat3} out
 **/

function fromMat2d(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = 0;
  out[3] = a[2];
  out[4] = a[3];
  out[5] = 0;
  out[6] = a[4];
  out[7] = a[5];
  out[8] = 1;
  return out;
}
/**
 * Calculates a 3x3 matrix from the given quaternion
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat3} out
 */

function fromQuat(out, q) {
  var x = q[0],
      y = q[1],
      z = q[2],
      w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[3] = yx - wz;
  out[6] = zx + wy;
  out[1] = yx + wz;
  out[4] = 1 - xx - zz;
  out[7] = zy - wx;
  out[2] = zx - wy;
  out[5] = zy + wx;
  out[8] = 1 - xx - yy;
  return out;
}
/**
 * Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {ReadonlyMat4} a Mat4 to derive the normal matrix from
 *
 * @returns {mat3} out
 */

function normalFromMat4(out, a) {
  var a00 = a[0],
      a01 = a[1],
      a02 = a[2],
      a03 = a[3];
  var a10 = a[4],
      a11 = a[5],
      a12 = a[6],
      a13 = a[7];
  var a20 = a[8],
      a21 = a[9],
      a22 = a[10],
      a23 = a[11];
  var a30 = a[12],
      a31 = a[13],
      a32 = a[14],
      a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

  if (!det) {
    return null;
  }

  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  return out;
}
/**
 * Generates a 2D projection matrix with the given bounds
 *
 * @param {mat3} out mat3 frustum matrix will be written into
 * @param {number} width Width of your gl context
 * @param {number} height Height of gl context
 * @returns {mat3} out
 */

function projection(out, width, height) {
  out[0] = 2 / width;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = -2 / height;
  out[5] = 0;
  out[6] = -1;
  out[7] = 1;
  out[8] = 1;
  return out;
}
/**
 * Returns a string representation of a mat3
 *
 * @param {ReadonlyMat3} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str(a) {
  return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
/**
 * Returns Frobenius norm of a mat3
 *
 * @param {ReadonlyMat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8]);
}
/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @returns {mat3} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {ReadonlyMat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */

function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  return out;
}
/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {ReadonlyMat3} a the first operand
 * @param {ReadonlyMat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */

function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat3} a The first matrix.
 * @param {ReadonlyMat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2],
      a3 = a[3],
      a4 = a[4],
      a5 = a[5],
      a6 = a[6],
      a7 = a[7],
      a8 = a[8];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2],
      b3 = b[3],
      b4 = b[4],
      b5 = b[5],
      b6 = b[6],
      b7 = b[7],
      b8 = b[8];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
/**
 * Alias for {@link mat3.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link mat3.subtract}
 * @function
 */

var sub = subtract;

/***/ }),

/***/ 31437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": function() { return /* binding */ add; },
/* harmony export */   "angle": function() { return /* binding */ angle; },
/* harmony export */   "ceil": function() { return /* binding */ ceil; },
/* harmony export */   "clone": function() { return /* binding */ clone; },
/* harmony export */   "copy": function() { return /* binding */ copy; },
/* harmony export */   "create": function() { return /* binding */ create; },
/* harmony export */   "cross": function() { return /* binding */ cross; },
/* harmony export */   "dist": function() { return /* binding */ dist; },
/* harmony export */   "distance": function() { return /* binding */ distance; },
/* harmony export */   "div": function() { return /* binding */ div; },
/* harmony export */   "divide": function() { return /* binding */ divide; },
/* harmony export */   "dot": function() { return /* binding */ dot; },
/* harmony export */   "equals": function() { return /* binding */ equals; },
/* harmony export */   "exactEquals": function() { return /* binding */ exactEquals; },
/* harmony export */   "floor": function() { return /* binding */ floor; },
/* harmony export */   "forEach": function() { return /* binding */ forEach; },
/* harmony export */   "fromValues": function() { return /* binding */ fromValues; },
/* harmony export */   "inverse": function() { return /* binding */ inverse; },
/* harmony export */   "len": function() { return /* binding */ len; },
/* harmony export */   "length": function() { return /* binding */ length; },
/* harmony export */   "lerp": function() { return /* binding */ lerp; },
/* harmony export */   "max": function() { return /* binding */ max; },
/* harmony export */   "min": function() { return /* binding */ min; },
/* harmony export */   "mul": function() { return /* binding */ mul; },
/* harmony export */   "multiply": function() { return /* binding */ multiply; },
/* harmony export */   "negate": function() { return /* binding */ negate; },
/* harmony export */   "normalize": function() { return /* binding */ normalize; },
/* harmony export */   "random": function() { return /* binding */ random; },
/* harmony export */   "rotate": function() { return /* binding */ rotate; },
/* harmony export */   "round": function() { return /* binding */ round; },
/* harmony export */   "scale": function() { return /* binding */ scale; },
/* harmony export */   "scaleAndAdd": function() { return /* binding */ scaleAndAdd; },
/* harmony export */   "set": function() { return /* binding */ set; },
/* harmony export */   "sqrDist": function() { return /* binding */ sqrDist; },
/* harmony export */   "sqrLen": function() { return /* binding */ sqrLen; },
/* harmony export */   "squaredDistance": function() { return /* binding */ squaredDistance; },
/* harmony export */   "squaredLength": function() { return /* binding */ squaredLength; },
/* harmony export */   "str": function() { return /* binding */ str; },
/* harmony export */   "sub": function() { return /* binding */ sub; },
/* harmony export */   "subtract": function() { return /* binding */ subtract; },
/* harmony export */   "transformMat2": function() { return /* binding */ transformMat2; },
/* harmony export */   "transformMat2d": function() { return /* binding */ transformMat2d; },
/* harmony export */   "transformMat3": function() { return /* binding */ transformMat3; },
/* harmony export */   "transformMat4": function() { return /* binding */ transformMat4; },
/* harmony export */   "zero": function() { return /* binding */ zero; }
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49685);

/**
 * 2 Dimensional Vector
 * @module vec2
 */

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(2);

  if (_common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT != Float32Array) {
    out[0] = 0;
    out[1] = 0;
  }

  return out;
}
/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {ReadonlyVec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(2);
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */

function fromValues(x, y) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(2);
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the source vector
 * @returns {vec2} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  return out;
}
/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */

function set(out, x, y) {
  out[0] = x;
  out[1] = y;
  return out;
}
/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  return out;
}
/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  return out;
}
/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  return out;
}
/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to ceil
 * @returns {vec2} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  return out;
}
/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to floor
 * @returns {vec2} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  return out;
}
/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  return out;
}
/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec2} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  return out;
}
/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to round
 * @returns {vec2} out
 */

function round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  return out;
}
/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */

function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  return out;
}
/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0],
      y = b[1] - a[1];
  return x * x + y * y;
}
/**
 * Calculates the length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate length of
 * @returns {Number} length of a
 */

function length(a) {
  var x = a[0],
      y = a[1];
  return Math.hypot(x, y);
}
/**
 * Calculates the squared length of a vec2
 *
 * @param {ReadonlyVec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0],
      y = a[1];
  return x * x + y * y;
}
/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to negate
 * @returns {vec2} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  return out;
}
/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to invert
 * @returns {vec2} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  return out;
}
/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a vector to normalize
 * @returns {vec2} out
 */

function normalize(out, a) {
  var x = a[0],
      y = a[1];
  var len = x * x + y * y;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  return out;
}
/**
 * Calculates the dot product of two vec2's
 *
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1];
}
/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var z = a[0] * b[1] - a[1] * b[0];
  out[0] = out[1] = 0;
  out[2] = z;
  return out;
}
/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the first operand
 * @param {ReadonlyVec2} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec2} out
 */

function lerp(out, a, b, t) {
  var ax = a[0],
      ay = a[1];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = _common_js__WEBPACK_IMPORTED_MODULE_0__/* .RANDOM */ .FD() * 2.0 * Math.PI;
  out[0] = Math.cos(r) * scale;
  out[1] = Math.sin(r) * scale;
  return out;
}
/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y;
  out[1] = m[1] * x + m[3] * y;
  return out;
}
/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat2d} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat2d(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[2] * y + m[4];
  out[1] = m[1] * x + m[3] * y + m[5];
  return out;
}
/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat3} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1];
  out[0] = m[0] * x + m[3] * y + m[6];
  out[1] = m[1] * x + m[4] * y + m[7];
  return out;
}
/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {ReadonlyVec2} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec2} out
 */

function transformMat4(out, a, m) {
  var x = a[0];
  var y = a[1];
  out[0] = m[0] * x + m[4] * y + m[12];
  out[1] = m[1] * x + m[5] * y + m[13];
  return out;
}
/**
 * Rotate a 2D vector
 * @param {vec2} out The receiving vec2
 * @param {ReadonlyVec2} a The vec2 point to rotate
 * @param {ReadonlyVec2} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec2} out
 */

function rotate(out, a, b, rad) {
  //Translate point to the origin
  var p0 = a[0] - b[0],
      p1 = a[1] - b[1],
      sinC = Math.sin(rad),
      cosC = Math.cos(rad); //perform rotation and translate to correct position

  out[0] = p0 * cosC - p1 * sinC + b[0];
  out[1] = p0 * sinC + p1 * cosC + b[1];
  return out;
}
/**
 * Get the angle between two 2D vectors
 * @param {ReadonlyVec2} a The first operand
 * @param {ReadonlyVec2} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var x1 = a[0],
      y1 = a[1],
      x2 = b[0],
      y2 = b[1],
      // mag is the product of the magnitudes of a and b
  mag = Math.sqrt(x1 * x1 + y1 * y1) * Math.sqrt(x2 * x2 + y2 * y2),
      // mag &&.. short circuits if mag == 0
  cosine = mag && (x1 * x2 + y1 * y2) / mag; // Math.min(Math.max(cosine, -1), 1) clamps the cosine between -1 and 1

  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec2 to zero
 *
 * @param {vec2} out the receiving vector
 * @returns {vec2} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec2} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str(a) {
  return "vec2(" + a[0] + ", " + a[1] + ")";
}
/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec2} a The first vector.
 * @param {ReadonlyVec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
      a1 = a[1];
  var b0 = b[0],
      b1 = b[1];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
/**
 * Alias for {@link vec2.length}
 * @function
 */

var len = length;
/**
 * Alias for {@link vec2.subtract}
 * @function
 */

var sub = subtract;
/**
 * Alias for {@link vec2.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link vec2.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec2.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 2;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
    }

    return a;
  };
}();

/***/ }),

/***/ 77160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": function() { return /* binding */ add; },
/* harmony export */   "angle": function() { return /* binding */ angle; },
/* harmony export */   "bezier": function() { return /* binding */ bezier; },
/* harmony export */   "ceil": function() { return /* binding */ ceil; },
/* harmony export */   "clone": function() { return /* binding */ clone; },
/* harmony export */   "copy": function() { return /* binding */ copy; },
/* harmony export */   "create": function() { return /* binding */ create; },
/* harmony export */   "cross": function() { return /* binding */ cross; },
/* harmony export */   "dist": function() { return /* binding */ dist; },
/* harmony export */   "distance": function() { return /* binding */ distance; },
/* harmony export */   "div": function() { return /* binding */ div; },
/* harmony export */   "divide": function() { return /* binding */ divide; },
/* harmony export */   "dot": function() { return /* binding */ dot; },
/* harmony export */   "equals": function() { return /* binding */ equals; },
/* harmony export */   "exactEquals": function() { return /* binding */ exactEquals; },
/* harmony export */   "floor": function() { return /* binding */ floor; },
/* harmony export */   "forEach": function() { return /* binding */ forEach; },
/* harmony export */   "fromValues": function() { return /* binding */ fromValues; },
/* harmony export */   "hermite": function() { return /* binding */ hermite; },
/* harmony export */   "inverse": function() { return /* binding */ inverse; },
/* harmony export */   "len": function() { return /* binding */ len; },
/* harmony export */   "length": function() { return /* binding */ length; },
/* harmony export */   "lerp": function() { return /* binding */ lerp; },
/* harmony export */   "max": function() { return /* binding */ max; },
/* harmony export */   "min": function() { return /* binding */ min; },
/* harmony export */   "mul": function() { return /* binding */ mul; },
/* harmony export */   "multiply": function() { return /* binding */ multiply; },
/* harmony export */   "negate": function() { return /* binding */ negate; },
/* harmony export */   "normalize": function() { return /* binding */ normalize; },
/* harmony export */   "random": function() { return /* binding */ random; },
/* harmony export */   "rotateX": function() { return /* binding */ rotateX; },
/* harmony export */   "rotateY": function() { return /* binding */ rotateY; },
/* harmony export */   "rotateZ": function() { return /* binding */ rotateZ; },
/* harmony export */   "round": function() { return /* binding */ round; },
/* harmony export */   "scale": function() { return /* binding */ scale; },
/* harmony export */   "scaleAndAdd": function() { return /* binding */ scaleAndAdd; },
/* harmony export */   "set": function() { return /* binding */ set; },
/* harmony export */   "sqrDist": function() { return /* binding */ sqrDist; },
/* harmony export */   "sqrLen": function() { return /* binding */ sqrLen; },
/* harmony export */   "squaredDistance": function() { return /* binding */ squaredDistance; },
/* harmony export */   "squaredLength": function() { return /* binding */ squaredLength; },
/* harmony export */   "str": function() { return /* binding */ str; },
/* harmony export */   "sub": function() { return /* binding */ sub; },
/* harmony export */   "subtract": function() { return /* binding */ subtract; },
/* harmony export */   "transformMat3": function() { return /* binding */ transformMat3; },
/* harmony export */   "transformMat4": function() { return /* binding */ transformMat4; },
/* harmony export */   "transformQuat": function() { return /* binding */ transformQuat; },
/* harmony export */   "zero": function() { return /* binding */ zero; }
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49685);

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(3);

  if (_common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }

  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */

function length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return Math.hypot(x, y, z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function fromValues(x, y, z) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__/* .ARRAY_TYPE */ .WT(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */

function set(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */

function round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot(x, y, z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;

  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }

  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2];
  var bx = b[0],
      by = b[1],
      bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function hermite(out, a, b, c, d, t) {
  var factorTimes2 = t * t;
  var factor1 = factorTimes2 * (2 * t - 3) + 1;
  var factor2 = factorTimes2 * (t - 2) + t;
  var factor3 = factorTimes2 * (t - 1);
  var factor4 = factorTimes2 * (3 - 2 * t);
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function bezier(out, a, b, c, d, t) {
  var inverseFactor = 1 - t;
  var inverseFactorTimesTwo = inverseFactor * inverseFactor;
  var factorTimes2 = t * t;
  var factor1 = inverseFactorTimesTwo * inverseFactor;
  var factor2 = 3 * t * inverseFactorTimesTwo;
  var factor3 = 3 * factorTimes2 * inverseFactor;
  var factor4 = factorTimes2 * t;
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = _common_js__WEBPACK_IMPORTED_MODULE_0__/* .RANDOM */ .FD() * 2.0 * Math.PI;
  var z = _common_js__WEBPACK_IMPORTED_MODULE_0__/* .RANDOM */ .FD() * 2.0 - 1.0;
  var zScale = Math.sqrt(1.0 - z * z) * scale;
  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */

function transformMat4(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
      y = a[1],
      z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */

function transformQuat(out, a, q) {
  // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
  var qx = q[0],
      qy = q[1],
      qz = q[2],
      qw = q[3];
  var x = a[0],
      y = a[1],
      z = a[2]; // var qvec = [qx, qy, qz];
  // var uv = vec3.cross([], qvec, a);

  var uvx = qy * z - qz * y,
      uvy = qz * x - qx * z,
      uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);

  var uuvx = qy * uvz - qz * uvy,
      uuvy = qz * uvx - qx * uvz,
      uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);

  var w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2; // vec3.scale(uuv, uuv, 2);

  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));

  out[0] = x + uvx + uuvx;
  out[1] = y + uvy + uuvy;
  out[2] = z + uvz + uuvz;
  return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateX(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0];
  r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
  r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateY(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
  r[1] = p[1];
  r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateZ(out, a, b, rad) {
  var p = [],
      r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
  r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
  r[2] = p[2]; //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var ax = a[0],
      ay = a[1],
      az = a[2],
      bx = b[0],
      by = b[1],
      bz = b[2],
      mag1 = Math.sqrt(ax * ax + ay * ay + az * az),
      mag2 = Math.sqrt(bx * bx + by * by + bz * bz),
      mag = mag1 * mag2,
      cosine = mag && dot(a, b) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str(a) {
  return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
      a1 = a[1],
      a2 = a[2];
  var b0 = b[0],
      b1 = b[1],
      b2 = b[2];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _common_js__WEBPACK_IMPORTED_MODULE_0__/* .EPSILON */ .Ib * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var sub = subtract;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link vec3.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec3.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec3.length}
 * @function
 */

var len = length;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;

    if (!stride) {
      stride = 3;
    }

    if (!offset) {
      offset = 0;
    }

    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }

    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }

    return a;
  };
}();

/***/ })

}]);